export const subtitles = {
    "1": {
        "startTime": 20.55,
        "endTime": 25.51,
        "transcript": "Waqaa, wii MIke Williams-aaruunga. Waken Akiarmek taillruunga.",
        "translation": "Hello, I'm Mike Williams. I came from Akiak here."
    },
    "2": {
        "startTime": 25.51,
        "endTime": 29.25,
        "transcript": "Tau͡gaam wani umyuanek ikayuristeńi calilartua.",
        "translation": "But I work with mental health services."
    },
    "3": {
        "startTime": 30.86,
        "endTime": 37.89,
        "transcript": "Wani quyurvallruukut imumi imakunek Yupiit wani iinruitnek picirluta",
        "translation": "Some time ago, we held a large gathering here to talk about traditional Yup'ik medicine"
    },
    "4": {
        "startTime": 38.39,
        "endTime": 41.07,
        "transcript": "September 17 - 21st.",
        "translation": "September 17 - 21st."
    },
    "5": {
        "startTime": 41.37,
        "endTime": 52.58,
        "transcript": "Waten uumek umyuarteqluta piluta: man'a yuuyaralput wani pinirikaniisqelluku man'a yuulput.",
        "translation": "We met with this in mind: to strengthen our way of life in our lives here."
    },
    "6": {
        "startTime": 53.31,
        "endTime": 58.68,
        "transcript": "Waten makut wani kitugikanirluku-w' man'a",
        "translation": "To improve these things here"
    },
    "7": {
        "startTime": 58.88,
        "endTime": 66.2,
        "transcript": "Tua-i nallunricelluki makut ayagyuaput wani makunek Yuut wani yuuyarallratnek.",
        "translation": "To have our young people learn about the old Yup'ik way of life."
    },
    "8": {
        "startTime": 66.399,
        "endTime": 80.288,
        "transcript": "Cali, tua-i-w' aulukluki caliaqluki-ll' makut wani Yupiit wani iinrullrit tamaani yuullermeggni.",
        "translation": "Also, we want to take care of and work on Yup'ik medicine that they used in their lives long ago."
    },
    "9": {
        "startTime": 80.466,
        "endTime": 89.543,
        "transcript": "Waten makut wani Yuut wani yuungcaristellret wani nallunrirluki",
        "translation": "They should learn about these old Yup'ik healers"
    },
    "10": {
        "startTime": 89.555,
        "endTime": 95.433,
        "transcript": "Kap'itulit, cat-llu canek wani atulallret tamaani cali.",
        "translation": "Yup'ik acupuncturists, and the things they used back then"
    },
    "11": {
        "startTime": 95.433,
        "endTime": 103.777,
        "transcript": "Makut wani naunraat cali igaulluki, elliluki nallunritniararput.",
        "translation": "And write and put down these plants so that we will know them."
    },
    "12": {
        "startTime": 104.888,
        "endTime": 110.077,
        "transcript": "Cali makut wani elicungcarluki.",
        "translation": "Also, we should learn these."
    },
    "13": {
        "startTime": 110.088,
        "endTime": 117.776,
        "transcript": "Elicungcautekluki-w' tua-i elicungcarluki-ll' makut wani Yuut wani atullrit iinrut.",
        "translation": "We should teach and learn these things that Yupiit used as medicine."
    },
    "14": {
        "startTime": 118.233,
        "endTime": 131.188,
        "transcript": "Cali makut wani iinrut cali Yupiit wani atullrit cali makunun wani yuungcarvignun atuusqelluki",
        "translation": "We also want these hospitals to use these kinds of medicine that Yupiit used"
    },
    "15": {
        "startTime": 132.254,
        "endTime": 134.676,
        "transcript": "Maani wani avatemteńi.",
        "translation": "Here around us."
    },
    "16": {
        "startTime": 134.954,
        "endTime": 148.599,
        "transcript": "Cali makut wani qatellriit yuut tailriit akmaken pamani yuungcarvigmi calilriit cali nallunricelluki makunek wani Yuut wani iinruitnek.",
        "translation": "We also want these white people that came from downstates who work inland in the hospital to know about these kinds of Yup'ik medicine."
    },
    "17": {
        "startTime": 148.935,
        "endTime": 157.011,
        "transcript": "Cali makut wani tegganret-wa tua-i angukara'urluurtellriit, arnassagaurtellriit-llu tua-i",
        "translation": "And these elders, those who've become old men and old women"
    },
    "18": {
        "startTime": 158.255,
        "endTime": 164.533,
        "transcript": "Tua-i-w' man'a aulukellrat wani tua-i assirikaniisqumaluku",
        "translation": "We want their care to be better here"
    },
    "19": {
        "startTime": 165.255,
        "endTime": 171.099,
        "transcript": "Maaken-llu ayagcetenritlerkaat pitekluku cali tamana tangaaluku piluta.",
        "translation": "We also looked at how we don't want them to be sent away from here."
    },
    "20": {
        "startTime": 171.466,
        "endTime": 182.977,
        "transcript": "Waniw' waken uumek Kuigpagmek tailria Noel Polty nasviciiqaakut makunek wani Yupiit wani iinrullritnek.",
        "translation": "Now, Noel Polty who came from the Yukon here, will explain to us what Yupiit used as medicine."
    },
    "21": {
        "startTime": 183.165,
        "endTime": 190.565,
        "transcript": "Tua-i wangnek piciulriamek qanqatartua waniwa tua-i wii atullemnek.",
        "translation": "Now, I'm going to say something true that I have experienced."
    },
    "22": {
        "startTime": 191.077,
        "endTime": 197.688,
        "transcript": "Makut maa-i wavet ukut wani cagtellrenka waniwa ukut waniw' Yup'igtaat iinrut.",
        "translation": "These things that I've scattered here are Yup'ik medicine."
    },
    "23": {
        "startTime": 198.31,
        "endTime": 202.877,
        "transcript": "Wiinga atuqek'ngaqanka. Tamalkuita ukut aturanka.",
        "translation": "I've taken them. I've taken all of them."
    },
    "24": {
        "startTime": 203.532,
        "endTime": 215.155,
        "transcript": "Cali-llu makut, cali pill-at makut cali maa-i aturluki waniwa.",
        "translation": "I'm also taking these pills here."
    },
    "25": {
        "startTime": 216.888,
        "endTime": 223.999,
        "transcript": "Ukut waniwa tapeqluki ayuqluki wii atuqek'ngaqanka. Waniwa tangrraci.",
        "translation": "I am taking all of these together now. You see them."
    },
    "26": {
        "startTime": 224.077,
        "endTime": 228.344,
        "transcript": "Ukut-llu waniw' [?] pill, una-llu call' [?]",
        "translation": "These are [?] pills, and these are [?]."
    },
    "27": {
        "startTime": 228.354,
        "endTime": 238.921,
        "transcript": "Waniwa yuum naulluulriim arcaqerluku una cali ikayuutekciqaa. Waniwa iirumavkenaku qanrutkaqa.",
        "translation": "These will especially help a sick person. I am telling it without hiding it."
    },
    "28": {
        "startTime": 240.988,
        "endTime": 249.977,
        "transcript": "Okay, cali-llu waniwa caiggluut makut waniwa tangrraput.",
        "translation": "Okay, then the wormwood here, we see these now."
    },
    "29": {
        "startTime": 250.911,
        "endTime": 256.333,
        "transcript": "Makut waniwa imkut caiggluut-wa tua-i tangellruaci. Waniwa.",
        "translation": "You've seen these wormwood plants before. Here they are."
    },
    "30": {
        "startTime": 258.522,
        "endTime": 264.344,
        "transcript": "Kirciuquvci, qaivceńi maani uitalriamek kirciuquvci",
        "translation": "If you have pains, if you have pains here on your body"
    },
    "31": {
        "startTime": 265.022,
        "endTime": 269.299,
        "transcript": "Una waniwa au͡g'arluku waten",
        "translation": "Take this part off like this"
    },
    "32": {
        "startTime": 270.232,
        "endTime": 281.321,
        "transcript": "Au͡g'arraarluku qang'a-llu piyukuvciu caayumek kuv'vikraarluku im'um kircilriim nalliinun elliluku nemerluku.",
        "translation": "After removing it, and if you want to pour tea on it, put it where the pain is and wrap it."
    },
    "33": {
        "startTime": 281.822,
        "endTime": 286.266,
        "transcript": "Tua-i yuungcautekluki im' kirciullerpeceńun.",
        "translation": "Use them to treat your body pains."
    },
    "34": {
        "startTime": 286.355,
        "endTime": 289.91,
        "transcript": "Room-aliciquvci-llu tauna cali wavet elliluku.",
        "translation": "And if you have a lot of room, put that here too."
    },
    "35": {
        "startTime": 289.921,
        "endTime": 298.088,
        "transcript": "Wiinga makut wani waniw' waten ayuquciicetun mermek pirraarluki maavet aturturatuanka waten wani.",
        "translation": "Personally, after I steep these in water as they are like this, I apply them here like this."
    },
    "36": {
        "startTime": 298.354,
        "endTime": 300.532,
        "transcript": "Waten atu'uqluki.",
        "translation": "I used them like this."
    },
    "37": {
        "startTime": 300.544,
        "endTime": 303.033,
        "transcript": "Tua-i ikayuutekluki.",
        "translation": "They help me."
    },
    "38": {
        "startTime": 303.043,
        "endTime": 308.854,
        "transcript": "Man'a kirciraqan mat'umek atu'uqluki. Waniw'.",
        "translation": "When this is in pain, I use these. Here they are."
    },
    "39": {
        "startTime": 310.988,
        "endTime": 318.199,
        "transcript": "Una waniwa, waniwa kinercirraarluku waten uutun kinqan",
        "translation": "This, after drying it and it gets dry like this one"
    },
    "40": {
        "startTime": 318.211,
        "endTime": 323.366,
        "transcript": "Waten tunguriqreskan like this, waten tunguriqreskan",
        "translation": "When it gets dark like this [one], when it gets dark like this"
    },
    "41": {
        "startTime": 323.455,
        "endTime": 329.477,
        "transcript": "Nutaan ulugluku waten. Uluggaarluku Wesson oil-amek auluku.",
        "translation": "Then crumple it like this. After crumpling it, add in Wesson oil."
    },
    "42": {
        "startTime": 329.722,
        "endTime": 339.088,
        "transcript": "Infect-alriamun kilinermun waten tua-i au͡gaulluku waten elliluku infect-aqan patuluku-llu.",
        "translation": "Take this off a part of it and put it on an infected wound like this if it's infected, and cover it."
    },
    "43": {
        "startTime": 339.333,
        "endTime": 345.921,
        "transcript": "Unugpak au͡g'arciqaa, nugciiqaa infect-alria qamani egmianun.",
        "translation": "All night, it will remove, pull out the infection inside right away."
    },
    "44": {
        "startTime": 345.933,
        "endTime": 353.133,
        "transcript": "Canarqevkenani-llu, kinguani-llu clean-arnarqevkenani nugcimaluni.",
        "translation": "And nothing [else] needs to be done, doesn't need to be cleaned since it was pulled out."
    },
    "45": {
        "startTime": 353.41,
        "endTime": 360.255,
        "transcript": "Cali-llu imumek qaisi man' ungilaggluni waten pikan, cakneq ungilaggluni",
        "translation": "Also, if your body here is itching like this, itching terribly"
    },
    "46": {
        "startTime": 360.265,
        "endTime": 369.332,
        "transcript": "Una wani mermun hot water-aamun ekqerraarluku ilakluku perriutekluku waten, perrirluku man'a qaini.",
        "translation": "After putting this in hot water, use it to wipe like this, wipe one's body like this."
    },
    "47": {
        "startTime": 369.888,
        "endTime": 378.277,
        "transcript": "Cali-llu nasqumteńi, qamiqumteńi cali ungilageskan [?]cukan makuciq cali elliluku waten.",
        "translation": "Also, if our heads are itching, tending to [?], put this kind here like this."
    },
    "48": {
        "startTime": 378.288,
        "endTime": 384.655,
        "transcript": "Wavet ellirraarluku canvas-amek ellivikluku nutaan unugpak qavarluni.",
        "translation": "After putting it here, one should put a canvas on it and sleep all night."
    },
    "49": {
        "startTime": 384.666,
        "endTime": 390.988,
        "transcript": "Unuaquani tupagciquq imna qavani infect-allra nasquani nugtellinikii.",
        "translation": "He will wake up the next morning with that having pulled out the infection from his head in his sleep."
    },
    "50": {
        "startTime": 391.566,
        "endTime": 396.333,
        "transcript": "Waniw' nallunritarci, you know, that leaf tobacco, cuyaq.",
        "translation": "You know this, you know, that leaf tobacco, \"cuyaq.\""
    },
    "51": {
        "startTime": 396.666,
        "endTime": 403.877,
        "transcript": "Cali kilip'akuni, ilii-llu kiliquni iliin yuum waniw' qang'a-llu two inch taktakan",
        "translation": "If one also has a big wound, if some person has a wound, or else if it's two inches long"
    },
    "52": {
        "startTime": 404.399,
        "endTime": 411.144,
        "transcript": "Nani yuungcautaunani, tau͡gaam waten blackbull-anek makunek pingqerquni cuyanek",
        "translation": "If there are no doctors, but if he has these blackbull leaves with him"
    },
    "53": {
        "startTime": 411.199,
        "endTime": 421.466,
        "transcript": "Tua-i camek pikailami una tua-i cuyaq mermek imirraarluku tuavet elliluku cali ataam, nemerluku-llu pikuniu",
        "translation": "Without any other alternative, after filling that tobacco leaf with water, if he also puts it there and binds it"
    },
    "54": {
        "startTime": 421.477,
        "endTime": 426.688,
        "transcript": "Qac'uqreskuni qat'riqreskuni aunrarngaituq.",
        "translation": "When it gets slack, when it gets white, it will not bleed."
    },
    "55": {
        "startTime": 426.688,
        "endTime": 429.266,
        "transcript": "Cali-llu mamciquq assirluni.",
        "translation": "It will also heal well."
    },
    "56": {
        "startTime": 429.699,
        "endTime": 436.543,
        "transcript": "Una imna kegguciqaqamta, tan'gaurlullrauluta iciw'-ggem mikluta kegguciqaqamta",
        "translation": "And this, when we had toothaches, you know, when we had toothaches as small boys"
    },
    "57": {
        "startTime": 436.554,
        "endTime": 443.332,
        "transcript": "Aluqatkanek au͡gaulluta kegguteput keggutelluki uitavkarlaqaitkut.",
        "translation": "We would take a piece of beaver castor, and they would have us bite it down on our teeth."
    },
    "58": {
        "startTime": 443.344,
        "endTime": 446.821,
        "transcript": "Tamakunek kegguciqsuucirluta.",
        "translation": "We used those for toothaches."
    },
    "59": {
        "startTime": 447.11,
        "endTime": 452.477,
        "transcript": "Cali-llu ak'a tua-i kegguciqsuutmek aipirluku",
        "translation": "Also, a long time ago, along with using it for toothaches"
    },
    "60": {
        "startTime": 452.488,
        "endTime": 457.443,
        "transcript": "Ukugnun wani uum tepii, aluqatkam tepii narevkallruagka.",
        "translation": "I had these two smell this scent, the beaver castor scent."
    },
    "61": {
        "startTime": 457.455,
        "endTime": 461.755,
        "transcript": "Ukuk malruulukek, waniw' uum-llu narluki, ing'um-llu narluki.",
        "translation": "There were two of them, this one smelled them, and the one over there smelled them."
    },
    "62": {
        "startTime": 461.765,
        "endTime": 467.065,
        "transcript": "Tuaten tepellgutkuk imkutun Kass'at-llu kegguciurcuutaicetun ayuqut.",
        "translation": "They smell the same like that, and they're like Western toothpaste."
    },
    "63": {
        "startTime": 467.077,
        "endTime": 470.499,
        "transcript": "Tuaten-llu elpegi'iqluki pituluteng.",
        "translation": "They also numb them like that."
    },
    "64": {
        "startTime": 471.41,
        "endTime": 476.988,
        "transcript": "Ukut waniwa tangrraci, una wani tungulriaruluni. Tang waniwa tunguuq.",
        "translation": "You see these, this black thing. You see, this is black."
    },
    "65": {
        "startTime": 477.377,
        "endTime": 485.544,
        "transcript": "Imkuugut teptukuyagnek pitukait, nunami atutuk[ait] tepsarqellriit.",
        "translation": "They're what they call beach greens, the odiferous things they use from the land."
    },
    "66": {
        "startTime": 485.554,
        "endTime": 490.821,
        "transcript": "Maa-i tepsarqut tamakucirnimek, nerellrat-llu assirluni cupugvagaqluni.",
        "translation": "They smell strongly of those, and they're good to eat, [?] very much."
    },
    "67": {
        "startTime": 490.832,
        "endTime": 498.132,
        "transcript": "Yuum igyariqekuni igyarani aviranarqekan pikailkuni yuilqumi pekeskuni",
        "translation": "If a person has a sore throat, his throat bothering him, if he has nothing as he travels in the wilderness"
    },
    "68": {
        "startTime": 498.144,
        "endTime": 501.766,
        "transcript": "Makucimek nerluni, mecua-ll' igmarluku.",
        "translation": "He should eat one of these, and swallow its juice."
    },
    "69": {
        "startTime": 502.355,
        "endTime": 512.066,
        "transcript": "Cali-llu qus'quni, cagmiqkuni waten makucimek tua-i maa-i nerluku, nernge'rmi igmange'rmiu",
        "translation": "Also, if one has a cold, if he is lost, when he eats this, though he eats and swallows it"
    },
    "70": {
        "startTime": 512.088,
        "endTime": 515.332,
        "transcript": "Tua-i qamani tau͡gaam cupugvagluni",
        "translation": "It will emanate a scent inside"
    },
    "71": {
        "startTime": 515.343,
        "endTime": 523.699,
        "transcript": "Imkucetun imkut iciw' Vicks-at cupugvaglalriit? Tuacetun tua-i cupugvagluni man'a piarkauguq.",
        "translation": "Like those, you know how Vicks emanates a strong scent? This will emanate a scent like that."
    },
    "72": {
        "startTime": 523.71,
        "endTime": 527.177,
        "transcript": "Waniwa ukut wani teptukuyagnek piaqluki.",
        "translation": "They call these beach greens."
    },
    "73": {
        "startTime": 527.177,
        "endTime": 529.854,
        "transcript": "Tua-i-llu cali waniwa",
        "translation": "Then these too"
    },
    "74": {
        "startTime": 530.355,
        "endTime": 533.777,
        "transcript": "Nutaan ukut wani.",
        "translation": "These especially."
    },
    "75": {
        "startTime": 538.11,
        "endTime": 542.121,
        "transcript": "Waniwa ayuqenritut. Ukut wani tangrraci.",
        "translation": "These are different. You see these here."
    },
    "76": {
        "startTime": 542.444,
        "endTime": 545.999,
        "transcript": "Una waniwa fresh-alriaruuq una.",
        "translation": "This here is fresh."
    },
    "77": {
        "startTime": 546.01,
        "endTime": 554.321,
        "transcript": "Una caiggluk fresh-arluni qallaucimaluni. Uum egneqaa. Waniw' waten ayuquq nutarauluni.",
        "translation": "This is freshly boiled. This is the liquid from this [plant]. This is what it's like when fresh."
    },
    "78": {
        "startTime": 559.432,
        "endTime": 565.054,
        "transcript": "Una wani waniw' caiggluum angucalua arnacalua-llu.",
        "translation": "This is the male and female parts of wormwood."
    },
    "79": {
        "startTime": 565.066,
        "endTime": 569.91,
        "transcript": "Quyurrlutek egalukek waten katurrlukek pinirluni.",
        "translation": "It is potent when they're boiled together."
    },
    "80": {
        "startTime": 569.922,
        "endTime": 575.888,
        "transcript": "Waten-llu color-angqerrluni waniwa nutaraunrilami, nalaciraullruami.",
        "translation": "And it has this color because it's not fresh, because it was dried."
    },
    "81": {
        "startTime": 577.755,
        "endTime": 588.311,
        "transcript": "Ukuk waniwa yuum una wani iluminek qamani, ilumini qamani ca aviranarqekan",
        "translation": "These two, if a person has stomach problems inside, if something in his stomach is bothering him"
    },
    "82": {
        "startTime": 589.688,
        "endTime": 599.654,
        "transcript": "Ilukaaquni-llu, wall' quserpakuni, wall'u mat'umek qukaminek mat'umek aviraniurlaquni",
        "translation": "And if he has stomach pains, or has a bad cough, or if his back here is bothering him"
    },
    "83": {
        "startTime": 599.888,
        "endTime": 607.222,
        "transcript": "Wall'u imkunek naugiyukuni, imkunek ungilagtellrianek naugiyukuni",
        "translation": "Or if he has malignant growths, those itchy malignant growths"
    },
    "84": {
        "startTime": 607.566,
        "endTime": 615.844,
        "transcript": "Una wani nerevkenaku, ayuquciatun pivkenaku, kenirraarluku tua-i waken wani mer'aqluni",
        "translation": "If he doesn't eat this, not as it is, if he boils it and drinks from here"
    },
    "85": {
        "startTime": 615.855,
        "endTime": 625.177,
        "transcript": "Unuaq im' qanrutkellracetun ik'um mer'aqluni, unuakumi mer'aqluni, atakumi-ll' mer'aqluni.",
        "translation": "If he drinks as the one across there said this morning, drinks in the morning, and drinks in the evening."
    },
    "86": {
        "startTime": 625.188,
        "endTime": 634.855,
        "transcript": "Tua-i-llu uum wani una pinialkekuniu nutaan makunek auluku waten wani",
        "translation": "Then if he finds that too weak, he should add these like this"
    },
    "87": {
        "startTime": 635.399,
        "endTime": 642.088,
        "transcript": "Waken kina meq'uni, one cup waken meq'uni aayalnguqerciiquq.",
        "translation": "If someone drinks from here, if he drinks one cup from here, he will get dizzy."
    },
    "88": {
        "startTime": 642.244,
        "endTime": 647.277,
        "transcript": "Pinirtut makut waten tapeqluteng makut, uumek tapirluteng.",
        "translation": "These are strong when added together like this, with this added in."
    },
    "89": {
        "startTime": 648.065,
        "endTime": 657.177,
        "transcript": "Tau͡gaam pininge'rmi eliskuniu, elitaqamiu yuum imucetun meqsulriacetun merlaraa.",
        "translation": "But though it's strong, when a person gets used to it, he drinks it as if thirsting for it."
    },
    "90": {
        "startTime": 657.188,
        "endTime": 662.643,
        "transcript": "Wiinga tua-i cup-amek mertu'rlartua unuaquaqan tua-i waten pinilriarrlainarmek.",
        "translation": "Personally, I always drink a cup every morning, only from this potent one."
    },
    "91": {
        "startTime": 662.655,
        "endTime": 665.977,
        "transcript": "Atam tangerqercia waniw.",
        "translation": "Look at me now."
    },
    "92": {
        "startTime": 665.988,
        "endTime": 672.499,
        "transcript": "Kemgicaaqellrulua, kemenglua-llu waniwa, mat'um.",
        "translation": "I had been underweight, now I put some on from this."
    },
    "93": {
        "startTime": 672.599,
        "endTime": 683.054,
        "transcript": "Ukut yuungcautet, ukut-llu-w' pill-at ikayuqluteng caliarat maa-i elpekumaaqa.",
        "translation": "I feel the full effects of these [traditional] medicine and these pills working together."
    },
    "94": {
        "startTime": 686.432,
        "endTime": 695.943,
        "transcript": "Tua-i-ll' una wani ukugtun ayuqsaaquq waten keniumaluni. Una kenirauguq.",
        "translation": "Then this is like these two, boiled like this. This has been boiled."
    },
    "95": {
        "startTime": 695.954,
        "endTime": 707.332,
        "transcript": "Imkunek maa-i napanek pilaraput maani ilaita, wangkuta-llu enrilnguarnek piaqluki qagaani imkut enrilnguat imkut moose-at ner'tukait.",
        "translation": "Some peopel from here call them trees, and we call them willow shoots, those willow shoots out there that moose eat."
    },
    "96": {
        "startTime": 707.61,
        "endTime": 711.821,
        "transcript": "Tua-i-llu cali qallaulluku waten qallarvaulluku.",
        "translation": "Then boil it like this also."
    },
    "97": {
        "startTime": 711.832,
        "endTime": 717.666,
        "transcript": "Mikelngurnun, cali una waniwa piniq'apiartuq mikelngurnun.",
        "translation": "To children, this is also very potent to children."
    },
    "98": {
        "startTime": 718.021,
        "endTime": 725.032,
        "transcript": "Callareskan qanrunani-llu pikan egmian qanrarnun kuvluku igengraani canrituq.",
        "translation": "If he has sores, and cannot use his mouth, immediately pour it in his mouth, and it's fine if he swallows it."
    },
    "99": {
        "startTime": 725.233,
        "endTime": 736.244,
        "transcript": "Una wani callartellrianun mikelngurnun, qainganun-llu cali maani imkunun waten callarnernun cali tamaavet kuvuurluku, aunrangraan kuvuurluku.",
        "translation": "Use this for children with sores, and pour it on the sores that he has on his body, pour it even if they bleed."
    },
    "100": {
        "startTime": 736.255,
        "endTime": 739.733,
        "transcript": "Cali mamciiqaa patagmek.",
        "translation": "It will also heal him right away."
    },
    "101": {
        "startTime": 739.743,
        "endTime": 748.466,
        "transcript": "Wangkuta-llu cali taqnerni, taqnerungramta waniwa cali qanerput calla'artetulria iliini pivakarluta.",
        "translation": "And we adults, though we are adults, sometimes our mouths get sores as we go."
    },
    "102": {
        "startTime": 748.466,
        "endTime": 755.455,
        "transcript": "Tua-i merluta tau͡gken meqsiirrluni-llu egmian. Pinirtuq, tukniuq makuciq atullra.",
        "translation": "We drink, and we're immediately not thirsty anymore. Using these is strong, potent."
    },
    "103": {
        "startTime": 755.466,
        "endTime": 763.066,
        "transcript": "Cali tua-i uum qaini ungilageskan cali makucetun, waten tua-i makucetun",
        "translation": "Also, if a person's body is itchy, like this too, like this"
    },
    "104": {
        "startTime": 763.066,
        "endTime": 771.455,
        "transcript": "Tua-i qaiminun maqikuni, wall'u nasquminun-llu maqikuni tua-i aturarkauluku.",
        "translation": "He will use it on his body when he takes a steam bath, or on his head.."
    },
    "105": {
        "startTime": 771.465,
        "endTime": 777.743,
        "transcript": "Imkut-llu nauw' unatmegteggun waten ungilaksuarturluteng tegucunairut'lalriit-llu waten.",
        "translation": "And you know how their hands are so itchy like this that they can't take anything like this."
    },
    "106": {
        "startTime": 777.744,
        "endTime": 786.788,
        "transcript": "Cali makucimun erurluki, waten erurraarluki tua-i mingunrilengraata tuaten eru'uqluki.",
        "translation": "Wash them in this as well, then after washing them, you don't need to apply anything, just wash them like that."
    },
    "107": {
        "startTime": 786.954,
        "endTime": 795.954,
        "transcript": "Cali mamciiqaa makucim waniwa enrilnguat imkut piit, egenrat.",
        "translation": "This kind will also heal it, the, you know, willow shoot broth."
    },
    "108": {
        "startTime": 796.521,
        "endTime": 800.277,
        "transcript": "Wiinga tua-i umyuarteqlartua waten wani:",
        "translation": "This is what I think:"
    },
    "109": {
        "startTime": 800.377,
        "endTime": 810.844,
        "transcript": "Makut wani Kass'at imumek [?] kapsaraakut. Piciatun naullutengqerraqamta nauullutvut tauna tangerrluku kaptuakut.",
        "translation": "These Caucasians would give us [?] shots. When we have various sicknesses, they look at our ailment and give us shots."
    },
    "110": {
        "startTime": 811.054,
        "endTime": 813.766,
        "transcript": "Tua-i-llu wii umyuarteqlartua",
        "translation": "Then I think"
    },
    "111": {
        "startTime": 813.899,
        "endTime": 821.943,
        "transcript": "Ukut wani, una wani [?] ayuquq imucetun kaputetun atullra amllerami.",
        "translation": "These, this is like [?], the shot they give, because it has many uses."
    },
    "112": {
        "startTime": 821.955,
        "endTime": 830.933,
        "transcript": "Naulluulria-llu ilii, naulluulriim assirivkarlaraa. Patagmek-ll' iliikun assirivkarlaraa patagmek unakarkaugaqamiu.",
        "translation": "It also heals some who are sick. It also sometimes quickly heals those that it is meant to heal."
    },
    "113": {
        "startTime": 830.944,
        "endTime": 835.977,
        "transcript": "Tau͡gaam waten elliin ukvekekuniu",
        "translation": "But if that person believes in it like this"
    },
    "114": {
        "startTime": 835.988,
        "endTime": 843.454,
        "transcript": "Waten wangtun wiinga una waniwa qanganaruaq pirpakaqa ikayuumiinga.",
        "translation": "Like me, I highly value this wormwood here because it helps me."
    },
    "115": {
        "startTime": 843.465,
        "endTime": 851.21,
        "transcript": "Imucetun kapsuutetun pitarrluku wiinga tua-i meryuglaraqa tua-i ikayuutellra pitekluku.",
        "translation": "I like to drink it, [beliving] it as much as those shots, because it helps."
    },
    "116": {
        "startTime": 851.221,
        "endTime": 859.832,
        "transcript": "Tuaten cali imkut makut Kass'at imkut [?] kapun imna tua-i ellaita pirpakaat ikayurlaateng.",
        "translation": "Like that, Caucasians also value the [?] shot because it helps them."
    },
    "117": {
        "startTime": 859.833,
        "endTime": 862.6,
        "transcript": "Wiinga-ll' ikayurlaraatnga tamakut.",
        "translation": "Those [plants] also help me."
    },
    "118": {
        "startTime": 862.621,
        "endTime": 875.188,
        "transcript": "Ukut waniwa yuungcautet Kass'at iinruit, wall'u wangkuta iinruput ikayuqluteng calikuneng atam assilliniuq.",
        "translation": "If these kinds of medicine work together, Western medicine, and our medicing, you see, it's good."
    },
    "119": {
        "startTime": 875.333,
        "endTime": 881.199,
        "transcript": "Piunrilkevkenaki Yup'igtaat, piunrilkevkenaki-llu Kass'at piit.",
        "translation": "Do not belittle Yup'ik [medicine], and do not belittle Western ones."
    },
    "120": {
        "startTime": 882.61,
        "endTime": 889.055,
        "transcript": "Tua-i waniwa wiinga umyuarteqlartua waten wani:",
        "translation": "Me personally, I think like this:"
    },
    "121": {
        "startTime": 889.243,
        "endTime": 896.588,
        "transcript": "Makut wani Agayutem piliaqai, nunam qaingani nauvkarluki.",
        "translation": "These are God's creations, having them grow on the land."
    },
    "122": {
        "startTime": 896.933,
        "endTime": 902.977,
        "transcript": "Agayutem piliarrlainarnek taqellrinek maa-i nunam qainga pitangqertuq.",
        "translation": "The land is filled only with what God created."
    },
    "123": {
        "startTime": 903.055,
        "endTime": 912.977,
        "transcript": "Makut wani Agayutem taqellrullinii wangkutnun Yugnun ikayuutekesqelluki yuungcautekluki, iinrukluki pisqelluki.",
        "translation": "God made these to help us Yupiit, so that we could use them for healing and medicine."
    },
    "124": {
        "startTime": 912.988,
        "endTime": 918.466,
        "transcript": "Wangkutnek qaill' atullerkaat yuarluku arenqillrakun.",
        "translation": "We look for the successful ways to use them by ourselves."
    },
    "125": {
        "startTime": 918.477,
        "endTime": 923.299,
        "transcript": "Tamaaggun tamana aturluku wangkuta piarkaugukut.",
        "translation": "Through that, we must use them like that."
    },
    "126": {
        "startTime": 923.31,
        "endTime": 927.41,
        "transcript": "Piliamteńek wangkuta, wiinga caigglulisciigatua.",
        "translation": "Through what we made, I cannot make wormwood."
    },
    "127": {
        "startTime": 927.422,
        "endTime": 933.911,
        "transcript": "Una Agayutem piliaqaa wangnun atuusqelluku, elpeceńun-llu atuusqelluku tamarpeci.",
        "translation": "This is God's creations for me to use, and for all of you to use."
    },
    "128": {
        "startTime": 935.222,
        "endTime": 946.455,
        "transcript": "Yaa, waniw' cali quyaviksugluku una Dela Keetz-aaq waken Malimiunek tailria Kotzebue-mek makunek cali nasvicarturluta",
        "translation": "Okay, I want to thenk Dela Keetz who came from Kotzebue in the [Iñupiaq] Malimiut region to show us these"
    },
    "129": {
        "startTime": 946.466,
        "endTime": 950.866,
        "transcript": "Yaa, tua-i yuungcautmeggnek ellait.",
        "translation": "Yes, their [traditional] medicine."
    },
    "130": {
        "startTime": 950.877,
        "endTime": 955.233,
        "transcript": "Quyavikluku makunek nasvicakut.",
        "translation": "I thank her for showing us these."
    },
    "131": {
        "startTime": 955.966,
        "endTime": 963.432,
        "transcript": "I'm Dela Keetz from... my hometown is Noatak",
        "translation": "I'm Dela Keetz from... my hometown is Noatak"
    },
    "132": {
        "startTime": 964.221,
        "endTime": 969.632,
        "transcript": "Around 75 miles from Kotzebue, inland.",
        "translation": "Around 75 miles from Kotzebue, inland."
    },
    "133": {
        "startTime": 971.199,
        "endTime": 979.544,
        "transcript": "Dela Keetz-aarunga, Noatak-armiungulua yuinaat pingayun akimiarmek mile-anek yaaqsigtaluni Kotzebue-mek.",
        "translation": "I'm Dela Keetz from Noatak, 75 miles away from Kotzebue.."
    },
    "134": {
        "startTime": 979.554,
        "endTime": 985.166,
        "transcript": "Nugtartellruukut ilanka-llu Kotzebue-mun 1963-mi.",
        "translation": "My family and I moved to Kotzebue in 1963."
    },
    "135": {
        "startTime": 987.877,
        "endTime": 995.732,
        "transcript": "But the people don't know. I never try to show to the people the way I always help people at home.",
        "translation": "But the people don't know. I never try to show to the people the way I always help people at home."
    },
    "136": {
        "startTime": 996.499,
        "endTime": 1008.399,
        "transcript": "I work at home, my hometown, try to help people all my life.",
        "translation": "I work at home, my hometown, try to help people all my life."
    },
    "137": {
        "startTime": 1008.41,
        "endTime": 1013.299,
        "transcript": "Tau͡gaam tuanleng'e'rma yuut ikayulangramki nallullruatnga",
        "translation": "But though I was there and helped people, they didn't know me"
    },
    "138": {
        "startTime": 1013.31,
        "endTime": 1016.155,
        "transcript": "Enemni calilaama nunamteńi.",
        "translation": "Because I work at home in our village."
    },
    "139": {
        "startTime": 1016.165,
        "endTime": 1024.665,
        "transcript": "Ikayungnaquralaamki yuut assiriaqata quyalaama tememtun wii pitarrluki.",
        "translation": "Because I try to help people, I am thankful when they get better, as if it were my own body."
    },
    "140": {
        "startTime": 1026.899,
        "endTime": 1035.544,
        "transcript": "My heart, always happy, just like I have a joy, happy all the time.",
        "translation": "My heart, always happy, just like I have a joy, happy all the time."
    },
    "141": {
        "startTime": 1036.033,
        "endTime": 1039.688,
        "transcript": "They're just like my own body.",
        "translation": "They're just like my own body."
    },
    "142": {
        "startTime": 1039.7,
        "endTime": 1047.022,
        "transcript": "That's why I love to help people, anyplace wherever I go.",
        "translation": "That's why I love to help people, anyplace wherever I go."
    },
    "143": {
        "startTime": 1048.899,
        "endTime": 1054.677,
        "transcript": "I doesn't been trained.",
        "translation": "I doesn't been trained."
    },
    "144": {
        "startTime": 1055.354,
        "endTime": 1062.277,
        "transcript": "I never trained in the hospital, or in no place.",
        "translation": "I never trained in the hospital, or in no place."
    },
    "145": {
        "startTime": 1062.765,
        "endTime": 1073.565,
        "transcript": "Just by my own experience, and from the books I've read when I'm in school.",
        "translation": "Just by my own experience, and from the books I've read when I'm in school."
    },
    "146": {
        "startTime": 1074.411,
        "endTime": 1077.9,
        "transcript": "I was so interested.",
        "translation": "I was so interested."
    },
    "147": {
        "startTime": 1078.888,
        "endTime": 1085.566,
        "transcript": "Elitnaurumaksaitua, yuungcarvigmi-llu elitnaurumaksaunii, allani-llu.",
        "translation": "I wasn't trained, and I wasn't trained in the hospital, or in other places."
    },
    "148": {
        "startTime": 1085.577,
        "endTime": 1091.911,
        "transcript": "Tau͡gaam nallunrita'arqemkun calilartua kalikanek naaqellemkun elitnaurvigmi.",
        "translation": "But I work with what I know from the books I've read in school."
    },
    "149": {
        "startTime": 1091.922,
        "endTime": 1101.166,
        "transcript": "Cali-llu paqnak'allemkun anglanakelallemkun-llu naaqiaqama ellma taringevguarallemkun",
        "translation": "And with what little I understood when I read about what I found interesting and fun"
    },
    "150": {
        "startTime": 1101.177,
        "endTime": 1104.954,
        "transcript": "Kass'atun qanerturluta anglirillrunrilamta.",
        "translation": "Because we didn't grow up speaking English."
    },
    "151": {
        "startTime": 1104.966,
        "endTime": 1112.422,
        "transcript": "When something happen to us, when it's injured or accident or anything",
        "translation": "When sometime happen to us, when it's injured or accident or anything"
    },
    "152": {
        "startTime": 1114.444,
        "endTime": 1120.966,
        "transcript": "We should help this way or that way.",
        "translation": "We should help this way or that way."
    },
    "153": {
        "startTime": 1121.766,
        "endTime": 1124.477,
        "transcript": "Especially, be clean.",
        "translation": "Especially, be clean."
    },
    "154": {
        "startTime": 1127.066,
        "endTime": 1132.51,
        "transcript": "Tau͡gaam naaqiyaurcama, elitnauristemta naaqivkaryaurcanga",
        "translation": "But when we started reading, when our teacher had us start reading"
    },
    "155": {
        "startTime": 1132.522,
        "endTime": 1142.455,
        "transcript": "Paqnak'lallruanka qaillun tememta calilauciit, wall'u picurlagaqamta akngirtaqamta-llu qaillun calilauciit",
        "translation": "I used to be interested in how our bodies work, or how they work when we get into accidents or get hurt"
    },
    "156": {
        "startTime": 1142.766,
        "endTime": 1146.022,
        "transcript": "Qaillun-llu ikayuumallerkarput.",
        "translation": "And how we can be helped."
    },
    "157": {
        "startTime": 1146.032,
        "endTime": 1151.077,
        "transcript": "Cali-llu qaillun auluklerkaat wall'u kilirpagluteng pikata.",
        "translation": "And how to take care of them, or if they have large wounds."
    },
    "158": {
        "startTime": 1151.088,
        "endTime": 1158.988,
        "transcript": "Arcaqalriaruluku unatet-llu menuunaki cali caliaqesqumaluteng.",
        "translation": "More importantly, they were instructed to work with clean hands."
    },
    "159": {
        "startTime": 1158.999,
        "endTime": 1162.066,
        "transcript": "Tuaten elitellruunga wiinga.",
        "translation": "That's the way I learned."
    },
    "160": {
        "startTime": 1162.077,
        "endTime": 1166.243,
        "transcript": "Igaulluki piksaileng'e'rma umyuaqelaranka.",
        "translation": "Even though I didn't write them down, I remember them."
    },
    "161": {
        "startTime": 1166.255,
        "endTime": 1171.632,
        "transcript": "Elitnauristem-llu naaqevkalallri umyuaquralaranka.",
        "translation": "I also always remember what the teacher had us read."
    },
    "162": {
        "startTime": 1171.643,
        "endTime": 1178.099,
        "transcript": "Tuaten yuut ikayuangnaqlemni tamakutgun umyuamnelngurteggun ikayungnaqaqluki.",
        "translation": "When I try to help people through that, I try to help them through those things that are in my mind."
    },
    "163": {
        "startTime": 1178.111,
        "endTime": 1182.133,
        "transcript": "I never forget it. It's in my mind all the time.",
        "translation": "I never forget it. It's in my mind all the time."
    },
    "164": {
        "startTime": 1182.133,
        "endTime": 1190.6,
        "transcript": "That is why I always help people when they need help.",
        "translation": "That is why I always help people when they need help."
    },
    "165": {
        "startTime": 1194.665,
        "endTime": 1198.843,
        "transcript": "I've got lot of things",
        "translation": "I've got lot of things"
    },
    "166": {
        "startTime": 1201.71,
        "endTime": 1204.855,
        "transcript": "Just a lot of things to say.",
        "translation": "Just a lot of things to say."
    },
    "167": {
        "startTime": 1204.855,
        "endTime": 1211.3,
        "transcript": "But what I do, I learned from myself.",
        "translation": "But what I do, I learned from myself."
    },
    "168": {
        "startTime": 1214.277,
        "endTime": 1218.688,
        "transcript": "Ataucirqumek wangnek aknirtellruunga iqulua.",
        "translation": "I hurt myself one time and fell over."
    },
    "169": {
        "startTime": 1218.866,
        "endTime": 1224.311,
        "transcript": "Tamaggun-llu ayanqigteksaitelartua iquvillemkun.",
        "translation": "And I've never went through that way where I fell."
    },
    "170": {
        "startTime": 1224.322,
        "endTime": 1225.977,
        "transcript": "...in my life.",
        "translation": "...in my life."
    },
    "171": {
        "startTime": 1226.099,
        "endTime": 1231.977,
        "transcript": "I should be careful when I use ulu or knife when I cut",
        "translation": "I shoudl be careful when I use ulu or knife when I cut."
    },
    "172": {
        "startTime": 1231.988,
        "endTime": 1242.288,
        "transcript": "Tuamtell' cali uluarlua wall'u nuussitgun-llu kiliraqama, tuaten cali mulngaklua uumikuani aturaqamki pilartua.",
        "translation": "Then when I get cut usuing an ulu or a [Western] knife, I am also careful the next time I use them like that."
    },
    "173": {
        "startTime": 1242.299,
        "endTime": 1243.799,
        "transcript": "Just like that.",
        "translation": "Just like that."
    },
    "174": {
        "startTime": 1244.866,
        "endTime": 1249.599,
        "transcript": "And when I hurt on myself",
        "translation": "And when I hurt on myself"
    },
    "175": {
        "startTime": 1250.033,
        "endTime": 1254.433,
        "transcript": "Like one time...",
        "translation": "Like one time..."
    },
    "176": {
        "startTime": 1255.155,
        "endTime": 1260.755,
        "transcript": "Ataucirqumek naanguarluta pillemteńi akngirtellruunga wangnek.",
        "translation": "Once, when we were playing, I hurt myself."
    },
    "177": {
        "startTime": 1261.366,
        "endTime": 1269.444,
        "transcript": "Aitartenrutassiirluta pillemteńi aitarpallaglua wiinga pinruqangnaqvallaglua.",
        "translation": "When we had a wide mouth contest, I opened my mouth too far trying to win."
    },
    "178": {
        "startTime": 1269.811,
        "endTime": 1275.144,
        "transcript": "...make more wider mouth like this.",
        "translation": "...make more wider mouth like this."
    },
    "179": {
        "startTime": 1275.821,
        "endTime": 1278.11,
        "transcript": "And I so want to win.",
        "translation": "And I so want to win."
    },
    "180": {
        "startTime": 1278.122,
        "endTime": 1283.177,
        "transcript": "I open my mouth wide, and I can't close it.",
        "translation": "I open my mouth wide, and I can't close it."
    },
    "181": {
        "startTime": 1286.522,
        "endTime": 1289.311,
        "transcript": "It's [?], it's [?].",
        "translation": "It's [?], it's [?]."
    },
    "182": {
        "startTime": 1290.633,
        "endTime": 1295.855,
        "transcript": "I try, I try to talk, I can't talk.",
        "translation": "I try, I try to talk, I can't talk."
    },
    "183": {
        "startTime": 1297.521,
        "endTime": 1304.588,
        "transcript": "Qanqa-llu mamtesciiganaku, qanerciiganii-llu.",
        "translation": "And I couldn't fix my mouth, and I couldn't speak."
    },
    "184": {
        "startTime": 1305.122,
        "endTime": 1312.555,
        "transcript": "Tua-i-llu yuut nalluatgun wangnuk agluqugka taamekellruagka akngirtengraagnek.",
        "translation": "Then without the knowledge of people, I [?worked on] my jaw though it hurt."
    },
    "185": {
        "startTime": 1314.244,
        "endTime": 1324.81,
        "transcript": "So then I push it out while I was open...",
        "translation": "So then I push it out while I was open..."
    },
    "186": {
        "startTime": 1325.244,
        "endTime": 1330.411,
        "transcript": "Nuq'errlukek tua-llu ataam cingllemni ek'arrlutek.",
        "translation": "I pulled them, then when I pushed again, they went right in."
    },
    "187": {
        "startTime": 1330.933,
        "endTime": 1332.744,
        "transcript": "I put it back in.",
        "translation": "I put it back in."
    },
    "188": {
        "startTime": 1333.411,
        "endTime": 1337.833,
        "transcript": "So, I know how to work on it.",
        "translation": "So, I know how to work on it."
    },
    "189": {
        "startTime": 1337.943,
        "endTime": 1343.132,
        "transcript": "Qaillun-llu tuaten agluqugnek ek'illerkaqa nallunritaqa.",
        "translation": "I also know how to set jaws back like that."
    },
    "190": {
        "startTime": 1343.133,
        "endTime": 1350.233,
        "transcript": "Ataucirqumek cali Shaktoolik-aamun qayagaullruatnga ikayurcetaarluteng Kotzebue-mek.",
        "translation": "Once, they called me to go help in Shaktoolik from Kotzebue."
    },
    "191": {
        "startTime": 1350.521,
        "endTime": 1358.632,
        "transcript": "Tua-llu Shaktoolik-aamun ayagyaaqellrianga, tuani nasaurluq tuaten pillinian",
        "translation": "Then when I went to Shaktoolik, because that happened to a girl there"
    },
    "192": {
        "startTime": 1358.754,
        "endTime": 1368.454,
        "transcript": "Health aide-aata, iinriutiita-wa ekesciigatliniamikek elliin taum wani ayagcetliniluku Nome-amun.",
        "translation": "Because their health aide, their nurse, could set [her jaw] back, (s)he had her go to Nome."
    },
    "193": {
        "startTime": 1369.065,
        "endTime": 1378.554,
        "transcript": "Tuani pingayuni ernerni pilliuq, aitangqauralliniluni neresciiganani qanerciiganani-llu.",
        "translation": "It may have been three days that her mouth was open, unable to eat or speak."
    },
    "194": {
        "startTime": 1378.566,
        "endTime": 1386.91,
        "transcript": "Maliggluku ayallruunga. Tekicama Nome-amun piunga qanra aitangqaurluni qanerciiganani-llu.",
        "translation": "I traveled with her. When I arrived at Nome, I foudn that her mouth was open and she couldn't speak."
    },
    "195": {
        "startTime": 1386.922,
        "endTime": 1389.31,
        "transcript": "Qaneni mamtesciiganaku.",
        "translation": "She couldn't fix her mouth."
    },
    "196": {
        "startTime": 1389.322,
        "endTime": 1395.355,
        "transcript": "Tamaani-llu arnat uitallruut mikelnguyagaat-llu amllerrluteng, qialuteng tuaten.",
        "translation": "There were women there, and a lot of children, and they were even crying."
    },
    "197": {
        "startTime": 1395.899,
        "endTime": 1398.344,
        "transcript": "Water running..",
        "translation": "Water running."
    },
    "198": {
        "startTime": 1399.721,
        "endTime": 1405.677,
        "transcript": "She can't talk. She can't close his mouth.",
        "translation": "She can't talk. She can't close his [her] mouth."
    },
    "199": {
        "startTime": 1407.088,
        "endTime": 1413.266,
        "transcript": "And then there was ladies with lot of babies.",
        "translation": "And then there was ladies with lot of babies."
    },
    "200": {
        "startTime": 1413.932,
        "endTime": 1421.899,
        "transcript": "\"Who's this baby is this?\" \"That was mine,\" a young girl say. \"You better take this crybabies out.\"",
        "translation": "\"Who's this baby is this?\" \"That was mine,\" a young girl say. \"You better take this crybabies out.\""
    },
    "201": {
        "startTime": 1421.91,
        "endTime": 1427.099,
        "transcript": "Iliit wani qialria piaqa kitumun irniaqucianek.",
        "translation": "I asked whose child was the one that was crying."
    },
    "202": {
        "startTime": 1427.111,
        "endTime": 1431.288,
        "transcript": "Iliit ayagyuat nasaurluut qanertuq elliin irniaqniluku.",
        "translation": "One of the young girls said it was her child."
    },
    "203": {
        "startTime": 1431.3,
        "endTime": 1437.077,
        "transcript": "Cunawa tua-i tauna enaiqertii Shaktoolik-aami iinriurtiita.",
        "translation": "It turned out that it was the one who took the place of the nurse in Shaktoolik."
    },
    "204": {
        "startTime": 1437.332,
        "endTime": 1443.977,
        "transcript": "Qanrucamni anutesqelluku irniara anqerrutaa neplilriami caliyuumiitnilua.",
        "translation": "When I told her to take her child out because I didn't want to work in a noisy environment, she took [the child] out."
    },
    "205": {
        "startTime": 1443.988,
        "endTime": 1451.355,
        "transcript": "Cunawa paqnayugyaaqliniliria qaillun agluquk ataam eklerkaak.",
        "translation": "Apparently, she was curious about how to set [the girl's] jaw back."
    },
    "206": {
        "startTime": 1451.366,
        "endTime": 1454.899,
        "transcript": "Take her out running next door.",
        "translation": "Take her out running next door."
    },
    "207": {
        "startTime": 1454.921,
        "endTime": 1458.099,
        "transcript": "Before he come back, I fix it already.",
        "translation": "Before [s]he come back, I fix it already."
    },
    "208": {
        "startTime": 1458.11,
        "endTime": 1462.299,
        "transcript": "\"Ah, you fix it already? I was going to catch you [?].\"",
        "translation": "\"Ah, you fix it already? I was going to catch you [?].\""
    },
    "209": {
        "startTime": 1463.655,
        "endTime": 1469.444,
        "transcript": "I show him how to. She so want to see me; she so want to watch.",
        "translation": "I show him [her] how to. She so want to see me; she so want to watch."
    },
    "210": {
        "startTime": 1469.71,
        "endTime": 1474.122,
        "transcript": "Tau͡gaam uterpailgan ataam wiinga kitugtellruagka.",
        "translation": "But before she came back, I fixed them again."
    },
    "211": {
        "startTime": 1474.132,
        "endTime": 1483.199,
        "transcript": "Tua-llu utercan ayuqucirturaqa qaillun tuaten pilriamek pikan eklerkaak agluquk.",
        "translation": "Then when she came back, I instructed her how to set a jaw back if that happens."
    },
    "212": {
        "startTime": 1483.599,
        "endTime": 1492.832,
        "transcript": "Luuskaacuarmek tegumialaucirpetun saskan saarraliqatarluku, tuaten tegumiaqnaragken agluquk canitmun",
        "translation": "Just as you hold a small spoon to put sugar in your cup, hold the jaws to the side like that."
    },
    "213": {
        "startTime": 1492.843,
        "endTime": 1497.055,
        "transcript": "Qamiqurra-llu cakneq tegumiaqluku.",
        "translation": "And hold their head tight."
    },
    "214": {
        "startTime": 1497.066,
        "endTime": 1501.721,
        "transcript": "Nuq'errluku elatmun. Tuaten pilriani ek'artetuut.",
        "translation": "Pull it outward. They set right back when doing that."
    },
    "215": {
        "startTime": 1502.677,
        "endTime": 1506.833,
        "transcript": "Just lift it up little bit. It's easy.",
        "translation": "Just lift it up little bit. It's easy."
    },
    "216": {
        "startTime": 1509.644,
        "endTime": 1514.855,
        "transcript": "Don't have to send it to, way off to hospital.",
        "translation": "Don't have to sent it to, way off to hospital."
    },
    "217": {
        "startTime": 1514.877,
        "endTime": 1518.422,
        "transcript": "Ayagcetevkenaku yuungcarvigmun.",
        "translation": "Don't have them go to the hospital."
    },
    "218": {
        "startTime": 1518.433,
        "endTime": 1526.855,
        "transcript": "Tuamtellu ataucirqumek Anchorage-aami quyurvallratni qanerteksuklua cucukelliniatnga.",
        "translation": "Then one time, when they held a large gathering in Anchorage, they chose me to speak."
    },
    "219": {
        "startTime": 1526.877,
        "endTime": 1533.51,
        "transcript": "Tua-llu qaillun tusgen yuugareskan qalarutkellruaqa.",
        "translation": "Then I spoke about what to do when your shoulder gets dislocated."
    },
    "220": {
        "startTime": 1535.299,
        "endTime": 1545.177,
        "transcript": "And I talked about when you hurt your shoulder.",
        "translation": "And I talked about when you hurt your shoulder."
    },
    "221": {
        "startTime": 1546.844,
        "endTime": 1556.833,
        "transcript": "If you hurt this side, left side, can't lift your arm, be hurt, it's hurt, don't want to lift alright.",
        "translation": "If you hurt this side, left side, can't lift your arm, be hurt, it's hurt, don't want to lift alright."
    },
    "222": {
        "startTime": 1556.999,
        "endTime": 1562.811,
        "transcript": "Akngireskuvet tuaten iqsulirnerkun pikuvet tallin qulmun yaggluku",
        "translation": "If you hurt your left side like that, [unable] to lift your arm up"
    },
    "223": {
        "startTime": 1562.822,
        "endTime": 1573.533,
        "transcript": "Akngirnarqeciqsaaquq tau͡gaam ingluanek yuungcaristeḿun ayagyunrilkuvet elpenek qulmun nuqluku eksugngaan",
        "translation": "It may be painful, but if you don't want to go to the doctor, you can pull it up with your other arm and set it"
    },
    "224": {
        "startTime": 1573.544,
        "endTime": 1576.066,
        "transcript": "Wiinga tuaten pillruamku.",
        "translation": "Because I've done that."
    },
    "225": {
        "startTime": 1577.132,
        "endTime": 1579.966,
        "transcript": "Akngirtellruaqa tuska",
        "translation": "I hurt my shoulder"
    },
    "226": {
        "startTime": 1579.977,
        "endTime": 1590.166,
        "transcript": "Tua-llu qulmun yagtengnaqluku nangengqalua. Aipaanek tallima nuqluku qulmun, ek'arrluni-llu.",
        "translation": "Then I tried to pull it up as I was standing. I pulled it up with my other arm, and it set."
    },
    "227": {
        "startTime": 1590.177,
        "endTime": 1593.099,
        "transcript": "Tua-i-llu unaqserrluku uitaluku.",
        "translation": "Then I kept it limp."
    },
    "228": {
        "startTime": 1593.122,
        "endTime": 1596.455,
        "transcript": "Tua-i-llu pektaartelluku.",
        "translation": "Then I moved it around."
    },
    "229": {
        "startTime": 1596.833,
        "endTime": 1601.388,
        "transcript": "Tuaten naspaallemni assirillruuq, ek'artellruuq.",
        "translation": "When I tried that, it got better, got set back in."
    },
    "230": {
        "startTime": 1604.01,
        "endTime": 1607.155,
        "transcript": "Elpeceńek-llu tuaten piyugngaarci.",
        "translation": "You can do it by yourself like that too."
    },
    "231": {
        "startTime": 1607.166,
        "endTime": 1615.199,
        "transcript": "Tuani quyurtaallratni atakumi angun iliit igtelliniuq tuss'aratgun, akngirrluku-llu tusni.",
        "translation": "When they held their meetings, one of the men fell on the stairs, hurting his shoulder."
    },
    "232": {
        "startTime": 1615.222,
        "endTime": 1620.477,
        "transcript": "Umyuaqertellinia, \"Dela-m-ggem qanrutellruakut tuaten pisqelluku.\"",
        "translation": "He remembered it, \"Didn't Dela tell us to do that?\""
    },
    "233": {
        "startTime": 1620.488,
        "endTime": 1629.621,
        "transcript": "Tua-llu naspaaluni ellminek ekengnaqlerminiu ek'artelliniluku tuani quyurtaalriit allaniviatni.",
        "translation": "Then when he tried to set it, he set it back there where the people who went to the meeting were lodged."
    },
    "234": {
        "startTime": 1633.999,
        "endTime": 1645.077,
        "transcript": "Waniw' cali quyaviksugluku cali una Mercelas Williams tailria akmaken Ingqilit wani nuniitnek, Ingqilit yuungcaristiit.",
        "translation": "Now, I also want to tahnk Marcelas williams who came from Native American territory downstates, a Native American healer."
    },
    "235": {
        "startTime": 1645.088,
        "endTime": 1653.632,
        "transcript": "Cali makunek qalaruciiqaakuk, tau͡gaam im' Joe Albright-am mumigqurluki piciqa.",
        "translation": "He will also talk to us about these, but Joe Albright will provide translations."
    },
    "236": {
        "startTime": 1653.855,
        "endTime": 1661.011,
        "transcript": "...villages along the creeks, that's where these medicine things grow.",
        "translation": "...villages along the creeks, that's where these medicine things grow."
    },
    "237": {
        "startTime": 1661.543,
        "endTime": 1673.71,
        "transcript": "Tamaa-i-llu-gguq nunanun tagglermeggni kuiget ceńaitnun engelkartellruut, tua-i-gguq-wa iinruutulit tamaani kuigem ceńiini naulaata.",
        "translation": "He siad that back when they were going inland to the villages, they settled on the riverbanks, because those medicinal plants grew on the riverbank."
    },
    "238": {
        "startTime": 1674.143,
        "endTime": 1682.588,
        "transcript": "When the white man found us there, they called us Cree Indians because we live by the creeks.",
        "translation": "When the white man found us there, they called us Cree Indians because we live by the creeks."
    },
    "239": {
        "startTime": 1682.988,
        "endTime": 1692.455,
        "transcript": "Makut-gguq qatellriit yuut nalkellermeggni aterpagtellruut Kuigem-wa Yuinek",
        "translation": "He said that when these white people found them, they called them River People"
    },
    "240": {
        "startTime": 1692.466,
        "endTime": 1696.454,
        "transcript": "Tamaa-i kuigem nuniini engelkaringallrat pitekluku.",
        "translation": "Because they were setlled by the rivers back there."
    },
    "241": {
        "startTime": 1699.977,
        "endTime": 1708.766,
        "transcript": "If you have some children, infants, sometimes look at the base of the spine.",
        "translation": "If you have some children, infants, sometimes look at the base of the spine."
    },
    "242": {
        "startTime": 1708.777,
        "endTime": 1716.444,
        "transcript": "And if they got a blue spot right on the base of the spine, right along in here, then you and I are related.",
        "translation": "And if they got a blue spot right on the base of the spine, right along in here, then you and I are related."
    },
    "243": {
        "startTime": 1716.966,
        "endTime": 1722.344,
        "transcript": "Tua-llu-gguq mikelnguci murilkelaquvciki",
        "translation": "Then, he said that if you watch your children"
    },
    "244": {
        "startTime": 1722.354,
        "endTime": 1733.054,
        "transcript": "Maani tunuatni qukaat qul'araani aciqvani maani qiurrlugmek-gguq qiuqeggingalriamek tangerquvci",
        "translation": "Here on their backs right above their midsection down there, if you see a blue spot"
    },
    "245": {
        "startTime": 1733.066,
        "endTime": 1737.955,
        "transcript": "Tamaaggun-gguq nallunrilkiciu ilakuyucirput ellait-llu.",
        "translation": "He said to know that we are related to them through that."
    },
    "246": {
        "startTime": 1738.766,
        "endTime": 1741.143,
        "transcript": "Don't look mine. He's too old.",
        "translation": "Don't look mine. He's too old."
    },
    "247": {
        "startTime": 1743.255,
        "endTime": 1747.532,
        "transcript": "Ca imna aturani tangrresqenritaa.",
        "translation": "He said not to look at his clothes."
    },
    "248": {
        "startTime": 1747.71,
        "endTime": 1751.421,
        "transcript": "The little guys. Look at the little ones.",
        "translation": "The little guys. Look at the little ones."
    },
    "249": {
        "startTime": 1756.966,
        "endTime": 1768.422,
        "transcript": "Everywhere, wherever you go, all kinds of people, black, yellow, brown, white, blue, green, or whatever",
        "translation": "Everywhere, wherever you go, all kinds of people, black, yellow, brown, white, blue, green, or whatever"
    },
    "250": {
        "startTime": 1769.221,
        "endTime": 1775.888,
        "transcript": "We all share something in common: we are either healthy or sick.",
        "translation": "We all share something in common: we are either healthy or sick."
    },
    "251": {
        "startTime": 1776.188,
        "endTime": 1784.632,
        "transcript": "Tua-i-gguq cam tamiini nunam qaingani wall' ellam iluani tarriskuvci-wa",
        "translation": "He said that everywhere on the land, or if you go anywhere in the world"
    },
    "252": {
        "startTime": 1784.655,
        "endTime": 1791.421,
        "transcript": "Qaillun-gguq tua-i yuut ayuqeng'e'rmeng, qaingit-wa tungunge'rmeng qat'nge'rmeng-llu",
        "translation": "He said no matter what people are like, even if their skin is black or white"
    },
    "253": {
        "startTime": 1791.51,
        "endTime": 1801.21,
        "transcript": "Tua-i-gguq ayuqluteng. Cali man'a ayquciat ayuquq nangtequtengqerraqluteng-llu ayuqluteng.",
        "translation": "He said they're the same. And what they're like, they all suffer from sickness."
    },
    "254": {
        "startTime": 1802.577,
        "endTime": 1809.344,
        "transcript": "Even among white people, there are different kinds of white people within that group.",
        "translation": "Even among white people, there are different kinds of white people within that group."
    },
    "255": {
        "startTime": 1809.51,
        "endTime": 1815.655,
        "transcript": "Makut-llu-wa qatellrianek pilangramceteng ayuqeqapiaranritut.",
        "translation": "And even though we call these people white, they're not exactly the same."
    },
    "256": {
        "startTime": 1815.665,
        "endTime": 1821.121,
        "transcript": "Ataucimek kangingqenritut. Ayuqenritut makut qatellrianek pilalput.",
        "translation": "They're not of the same origin. The ones we call white are not the same."
    },
    "257": {
        "startTime": 1822.144,
        "endTime": 1827.088,
        "transcript": "To ones in Washington, D.C., we call them from the Paper Tribe.",
        "translation": "To ones in Washington, D.C., we call them from the Paper Tribe."
    },
    "258": {
        "startTime": 1827.099,
        "endTime": 1832.288,
        "transcript": "Everything is done on paper, [?] and all that.",
        "translation": "Everything is done on paper, [?] and all that."
    },
    "259": {
        "startTime": 1832.711,
        "endTime": 1843.422,
        "transcript": "Makut-gguq akmani nunarpagmek apqallranek kingunelget, tamakut-gguq Kalikat Tribe-artaitnek aterpagingalartut",
        "translation": "He said that the people from the city downstates that he mentioned, they're called the Paper Tribe"
    },
    "260": {
        "startTime": 1843.433,
        "endTime": 1848.199,
        "transcript": "Tua-i kalikaq aturluku-wa calilaata.",
        "translation": "Because they work with [official] paper[work]."
    },
    "261": {
        "startTime": 1851.188,
        "endTime": 1860.577,
        "transcript": "There are some referred to as hillbillies, and they also have folk ways, folk medicine.",
        "translation": "There are some referred to as hillbillies, and they also have folk ways, folk medicine."
    },
    "262": {
        "startTime": 1862.955,
        "endTime": 1869.111,
        "transcript": "Au͡gkunek-wa ca au͡gna hillbilly-mek tuar piqaqii niiquralalput",
        "translation": "It seemed that he called what we hear about a hillbilly"
    },
    "263": {
        "startTime": 1869.121,
        "endTime": 1874.355,
        "transcript": "Tamatum cam iinrutulim-gguq ilakukai.",
        "translation": "They are part of the ones who practice [folk] medicine."
    },
    "264": {
        "startTime": 1876.154,
        "endTime": 1882.454,
        "transcript": "[?] of mankind exist wherever they live.",
        "translation": "[?] of mankind exist wherever they live."
    },
    "265": {
        "startTime": 1883.522,
        "endTime": 1888.644,
        "transcript": "They always learn something from their area.",
        "translation": "They always learn something from their area."
    },
    "266": {
        "startTime": 1889.322,
        "endTime": 1898.422,
        "transcript": "Tua-i-gguq nunam qaingani tamiini ayuqluteng camek elicugngalartut nunameggnek.",
        "translation": "He said that everywhere on the land, they are the same in that they can learn something of their land."
    },
    "267": {
        "startTime": 1899.888,
        "endTime": 1910.199,
        "transcript": "If all of my people moved over here in this part of Alaska, they'd all probably starve to death this next winter.",
        "translation": "If all of my people moved over here in this part of Alaska, they'd all probably starve to death this next winter."
    },
    "268": {
        "startTime": 1910.811,
        "endTime": 1920.833,
        "transcript": "Tua-i ayuqestassiigutkaa. Tayima-gguq elliin ilakutai maavet nunamteńun pikuneng aipaagni-gguq paluyartut.",
        "translation": "He gave an example. He said that if his people moved here to our lands, they'd probably starve to death."
    },
    "269": {
        "startTime": 1921.155,
        "endTime": 1925.489,
        "transcript": "And if you all came to my country, you might melt",
        "translation": "And if you all came to my country, you might melt."
    },
    "270": {
        "startTime": 1926.244,
        "endTime": 1931.788,
        "transcript": "Nuniinun-llu-gguq wangkuta ayakumta aipaagni urugyalliakut.",
        "translation": "And he said that if we went to his lands, we would probably melt."
    },
    "271": {
        "startTime": 1932.688,
        "endTime": 1940.988,
        "transcript": "But in this time, we learn to adjust, we learn to adapt, we learn to live off the land.",
        "translation": "But in this time, we learn to adjust, we learn to adapt, we learn to live off the land."
    },
    "272": {
        "startTime": 1941.0,
        "endTime": 1946.422,
        "transcript": "We learn for things that you can eat, things that you can use for medicine.",
        "translation": "We learn for things that you can eat, thigns that you can use for medicine."
    },
    "273": {
        "startTime": 1946.677,
        "endTime": 1954.177,
        "transcript": "Tau͡gaam-gguq yuk alqunaq pinrilnge'rmi eliquratuuq cukavkenani.",
        "translation": "But he said that even if it doesn't happen right away, a person keeps learning slowly."
    },
    "274": {
        "startTime": 1954.177,
        "endTime": 1958.688,
        "transcript": "Nunam-llu qainganek nerrlerkani cali elicugngaluku",
        "translation": "He can also learn what he can eat from the land"
    },
    "275": {
        "startTime": 1958.7,
        "endTime": 1963.422,
        "transcript": "Wall'u-qaa iinrurkani-llu tamaaken elitarkauluku.",
        "translation": "Or he will also learn what he can use as medicine from there"
    },
    "276": {
        "startTime": 1964.532,
        "endTime": 1969.143,
        "transcript": "In the workshop we've been having, attending",
        "translation": "In the workshop we've been having, attending"
    },
    "277": {
        "startTime": 1970.011,
        "endTime": 1977.355,
        "transcript": "Each one has some knowledge about the land, and we've been sharing this knowledge all week.",
        "translation": "Each one has some knowledge about the land, and we've been sharing this knowledge all week."
    },
    "278": {
        "startTime": 1977.7,
        "endTime": 1987.411,
        "transcript": "Maa-i-wa uumirpak quyurtaallemteńi yuut nallunrilkaitnek elitellritnek-llu niiqurtukut",
        "translation": "Now, as we've been having these meetings, we've been hearing about what people know and have learned"
    },
    "279": {
        "startTime": 1987.421,
        "endTime": 1995.221,
        "transcript": "Tua-i nunameggni tamakut uitalriit nallunrillritnek elilluki-llu.",
        "translation": "The things people found out and learned about in their lands."
    },
    "280": {
        "startTime": 1996.7,
        "endTime": 2002.955,
        "transcript": "I'd like to just stay on for a long time and learn many of your ways.",
        "translation": "I'd like to just stay on for a long time and learn many of your ways."
    },
    "281": {
        "startTime": 2002.966,
        "endTime": 2008.866,
        "transcript": "For instance, we have lots of teachings in my tribe, similar to yours.",
        "translation": "For instance, we have lots of teachings in my tribe, similar to yours."
    },
    "282": {
        "startTime": 2009.11,
        "endTime": 2021.61,
        "transcript": "When a woman is expecting a child, when she goes out the door and changes her mind, we tell her not to turn around at the doorway.",
        "translation": "When a woman is expecting a child, when she goes out the door and changes her mind, we tell her not to turn around at the doorway."
    },
    "283": {
        "startTime": 2021.621,
        "endTime": 2024.477,
        "transcript": "Go on through, and then come back in.",
        "translation": "Go on through, and then come back in."
    },
    "284": {
        "startTime": 2025.389,
        "endTime": 2032.766,
        "transcript": "Maa-i-wa ellii-llu akaarnun tua-i maancuumiryaaqeng'e'rmi eliterllerkani pitekluku.",
        "translation": "Now, he wants to stay here from a long time so that he can learn."
    },
    "285": {
        "startTime": 2032.777,
        "endTime": 2043.855,
        "transcript": "Maa-i niicugniurallermikun cali kingunermini yum'i-wa ayuqucirtuutek'lallrit alerquatek'lallrit-llu iliini elitaq'larai.",
        "translation": "As he's been listening now, he sometimes recognizes his people's teachings and instructions back home"
    },
    "286": {
        "startTime": 2043.855,
        "endTime": 2053.043,
        "transcript": "Unaumek-llu cali elliin pillra-wa cali wangkutnun-am maani ciuliamta alerquutaitnun nall'arusngaluni.",
        "translation": "And what he talked about today, it is in accordance to our ancestors instructions here."
    },
    "287": {
        "startTime": 2053.055,
        "endTime": 2055.555,
        "transcript": "Man'a ayuqeltassiigutekluku:",
        "translation": "He used this as an example:"
    },
    "288": {
        "startTime": 2055.566,
        "endTime": 2061.344,
        "transcript": "Waten-gguq akmani kingunrani-wa ilakutai alerquutengqertut:",
        "translation": "He said that back at his home downstates, his people have this traditional instruction:"
    },
    "289": {
        "startTime": 2061.355,
        "endTime": 2073.377,
        "transcript": "Neviarcar qinga'arqan irnivailgan anyugluni umyuarteqkuni, tua-i-llu anyugyaaqerrluni umyuani cimiraqan",
        "translation": "When a young lady is pregnant before giving birth, if she things of going out, then changes her mind about wanting to go out"
    },
    "290": {
        "startTime": 2073.388,
        "endTime": 2077.522,
        "transcript": "Tamana cimiqallra ilangcivkenaku egmianun anqertesqelluku.",
        "translation": "Ignoring her change of mind, they tell her to go right out."
    },
    "291": {
        "startTime": 2077.533,
        "endTime": 2082.966,
        "transcript": "Tamatumek-gguq alerquutengqertut ciuliari.",
        "translation": "He said his ancestors have that traditional instruction."
    },
    "292": {
        "startTime": 2087.199,
        "endTime": 2094.088,
        "transcript": "We have learned much from the white man, good and bad.",
        "translation": "We have learned much from the white man, good and bad."
    },
    "293": {
        "startTime": 2094.444,
        "endTime": 2105.5,
        "transcript": "Maa-i-gguq wangkuta amllermek elitellrurtukut makunek qatellriartamteńek, assilrianek assiilngurnek-llu ayuqluku.",
        "translation": "He said that we've learned much from these white people among us, good and bad all the same."
    },
    "294": {
        "startTime": 2106.444,
        "endTime": 2111.744,
        "transcript": "Among all people, there are some good, there are some bad.",
        "translation": "Among all people, there are some good, there are some bad."
    },
    "295": {
        "startTime": 2112.033,
        "endTime": 2118.044,
        "transcript": "Tua-i-gguq tuaten ayuquq, tamakut nallmegteggun tuaten ayuqevkenateng.",
        "translation": "He said it's like that, with people being different among their own."
    },
    "296": {
        "startTime": 2118.077,
        "endTime": 2122.443,
        "transcript": "Nunam qaingani-gguq yuut tuaten ayuquq au͡g'utun.",
        "translation": "He said that people are like that, as he said."
    },
    "297": {
        "startTime": 2125.31,
        "endTime": 2134.788,
        "transcript": "If we look for something bad in other people, that will be easy to do. There's something bad in all of us.",
        "translation": "If we look for something bad in other people, that will be easy to do. There's something bad in all of us."
    },
    "298": {
        "startTime": 2135.255,
        "endTime": 2140.677,
        "transcript": "But it's another thing to look for something good. It's the better way.",
        "translation": "But it's another thing to look for something good. It's the better way."
    },
    "299": {
        "startTime": 2141.355,
        "endTime": 2152.188,
        "transcript": "Tua-llu-gguq wangkuta ilaput-wa tua-i [?]rrluki [?]lluulluki pikumta assiitellriamek ilamteggun nallunaillerkaanek",
        "translation": "Then, he said that if we [?] those around us [?looking] for something bad to be shown in those around us"
    },
    "300": {
        "startTime": 2152.2,
        "endTime": 2154.277,
        "transcript": "Tamana-gguq qacignarquq.",
        "translation": "He said that's easy."
    },
    "301": {
        "startTime": 2154.288,
        "endTime": 2161.755,
        "transcript": "Tau͡gaam assilriamek-wa tua-i pillerkaq pivigkartarluni cali.",
        "translation": "But there is also a place for something good."
    },
    "302": {
        "startTime": 2164.521,
        "endTime": 2175.41,
        "transcript": "Another thing that we all have in common is destruction",
        "translation": "Another thing that we all have in common is destruction"
    },
    "303": {
        "startTime": 2176.777,
        "endTime": 2183.044,
        "transcript": "By nature, and by man-made destruction.",
        "translation": "By nature, and by man-made destruction."
    },
    "304": {
        "startTime": 2183.41,
        "endTime": 2190.488,
        "transcript": "Mat'umek-gguq cali maa-i tua-i nallunrirciqukut niilluta-llu.",
        "translation": "He said that we will find out and hear about this."
    },
    "305": {
        "startTime": 2190.499,
        "endTime": 2198.033,
        "transcript": "Nallunairumalria-wa yuum qaillun piunrillerkaa cakun",
        "translation": "It's been shown that a person can be destoryed through something"
    },
    "306": {
        "startTime": 2198.044,
        "endTime": 2202.122,
        "transcript": "Wall'u yuum taqellrakun-llu piunriryugngacia.",
        "translation": "Or that he cane by destroyed by man-made things."
    },
    "307": {
        "startTime": 2204.022,
        "endTime": 2215.677,
        "transcript": "In nature's destruction, there's floods, tornadoes, hurricanes, earthquakes, fire, and things like that.",
        "translation": "In nature's destruction, there's floods, tornadoes, hurricanes, earthquakes, fire, and things like that."
    },
    "308": {
        "startTime": 2216.132,
        "endTime": 2223.855,
        "transcript": "Mat'um-gguq ellam ayuquciakun yuut piunriryarait ava-i aperturai",
        "translation": "He just mentioned the ways that people can be destroyed through natural phenomena"
    },
    "309": {
        "startTime": 2223.866,
        "endTime": 2230.599,
        "transcript": "Imkutgun nunam pekterpallrakun-llu, ingrit-llu qagrallritgun.",
        "translation": "Through those, earthquakes, and volcanic eruptions."
    },
    "310": {
        "startTime": 2230.61,
        "endTime": 2238.266,
        "transcript": "Tamaa-i wall'u ulerpagteggun, tamakutgun tua-i yuut piunriryugngaluteng.",
        "translation": "Through those, or through floods, people can be destroyed through those."
    },
    "311": {
        "startTime": 2239.61,
        "endTime": 2245.932,
        "transcript": "Man-made destructions, there's a lot of things. The list is too long.",
        "translation": "Man-made destructions, there's a lot of things. The list is too long."
    },
    "312": {
        "startTime": 2246.266,
        "endTime": 2249.288,
        "transcript": "There's bombs, [?war ?].",
        "translation": "There's bombs, [?war ?]."
    },
    "313": {
        "startTime": 2249.299,
        "endTime": 2255.811,
        "transcript": "World powers can't live together. They must try to dominate one another.",
        "translation": "World powers can't live together. They must try to dominate one another."
    },
    "314": {
        "startTime": 2256.266,
        "endTime": 2266.633,
        "transcript": "Cali-gguq maa-i-wa yugteggun taqumalriit yuut piunriryarait ayuqevkenateng.",
        "translation": "He said that there are different ways people can be destroyed by these man-made things."
    },
    "315": {
        "startTime": 2266.644,
        "endTime": 2274.3,
        "transcript": "Imukun-llu qagercetaakun, wall'u anguyaucarakun yuk amlleq piunriraqluni.",
        "translation": "Many people are also destroyed through bombs, or through war."
    },
    "316": {
        "startTime": 2274.3,
        "endTime": 2284.933,
        "transcript": "Ilateng-wa tua-i tegungnaqluki cirlakengnaqlermegteggu-llu tamaaggun tuaten piunrilartuq yuk amlleq.",
        "translation": "Trying to take over and dominate those around them, many people are destroyed through that."
    },
    "317": {
        "startTime": 2286.199,
        "endTime": 2296.554,
        "transcript": "This earth on which we live is known as a planet. It is a planet.",
        "translation": "This earth on which we live is known as a planet. It is a planet."
    },
    "318": {
        "startTime": 2296.677,
        "endTime": 2304.222,
        "transcript": "Man'a-gguq nunavut uitavigput, ava-i mumigtellerkaa nalluaqa.",
        "translation": "He said that our land where we live, I don't know how to translate it."
    },
    "319": {
        "startTime": 2304.233,
        "endTime": 2312.744,
        "transcript": "Tau͡gaam aperluku elitnaurani elitaqciqerci. Planet-aamek aterpagingauq man'a uitavigput.",
        "translation": "But if I say it, you students will recognize it. The place we live is called a planet."
    },
    "320": {
        "startTime": 2313.966,
        "endTime": 2319.532,
        "transcript": "There are nine in what we call solar system.",
        "translation": "There are nine in what we call solar system."
    },
    "321": {
        "startTime": 2319.533,
        "endTime": 2324.844,
        "transcript": "There are nine planets in this area around the sun.",
        "translation": "There are nine planets in this area around the sun."
    },
    "322": {
        "startTime": 2325.21,
        "endTime": 2335.166,
        "transcript": "Tamaa-i qulngunritaraugut mat'umcetun ayuqellriit akertem avatiini planet-aat.",
        "translation": "He said there are nine planets like ours here around the sun."
    },
    "323": {
        "startTime": 2336.366,
        "endTime": 2344.599,
        "transcript": "So far as we know now, this is the only planet that has life.",
        "translation": "So far as we know now, this is the only planet that has life."
    },
    "324": {
        "startTime": 2344.977,
        "endTime": 2350.033,
        "transcript": "Tua-i-gguq yuvriumallermegteggun tau͡gaam tuaten amllertang'e'rmeng",
        "translation": "He said that in all of their examinations, though there are that many"
    },
    "325": {
        "startTime": 2350.044,
        "endTime": 2356.444,
        "transcript": "Una-gguq tau͡aam wangkuta uitavigput unguvanarqellriamek pitangqerrluni.",
        "translation": "He said that where we live now is the only one that supports life."
    },
    "326": {
        "startTime": 2357.633,
        "endTime": 2363.244,
        "transcript": "With all the different people over our earth",
        "translation": "With all the different people over our earth"
    },
    "327": {
        "startTime": 2364.877,
        "endTime": 2373.399,
        "transcript": "We have a very unique place. This earth is very special.",
        "translation": "We have a very unique place. This earth is very special."
    },
    "328": {
        "startTime": 2373.711,
        "endTime": 2381.611,
        "transcript": "The Great Ones above saw to it that this will be a special place for man to live in.",
        "translation": "The Great Ones above saw to it that this will be a special place for man to live in."
    },
    "329": {
        "startTime": 2381.999,
        "endTime": 2387.566,
        "transcript": "Tua-i-gguq man'a ellavut yuvriumallermini",
        "translation": "He said that as they examined our world"
    },
    "330": {
        "startTime": 2387.577,
        "endTime": 2393.477,
        "transcript": "Waten-llu mat'utun uitavimcetun planet-aatun allat planet-aaruyaaqeng'e'rmeng",
        "translation": "And though the other planets like where we live now are planets"
    },
    "331": {
        "startTime": 2393.488,
        "endTime": 2404.044,
        "transcript": "Tau͡gaam Pak'mum-wa murilkestemta nallunritaa man'a kiimi waten uitaviksunarqucia uitavigput.",
        "translation": "But the One Above who watches over us knows that this place of ours is the only one viable to live in."
    },
    "332": {
        "startTime": 2405.022,
        "endTime": 2410.966,
        "transcript": "Many people refer to this earth as Mother Earth.",
        "translation": "Many people refer to this earth as Mother Earth."
    },
    "333": {
        "startTime": 2411.255,
        "endTime": 2418.788,
        "transcript": "Amlleret-gguq yuut aterpagtelaraat man'a nunavut Aanaulriamek.",
        "translation": "He said that many people refer to our earth here as a Mother."
    },
    "334": {
        "startTime": 2419.977,
        "endTime": 2426.921,
        "transcript": "My tribe has an endearing term. We call it Grandmother Earth.",
        "translation": "My tribe has an endearing term. We call it Grandmother Earth."
    },
    "335": {
        "startTime": 2427.221,
        "endTime": 2437.443,
        "transcript": "Iliin-llu, elliin-llu ilakutain tamakut ap'lalliniluku Maurlurmek Nunamek.",
        "translation": "And his people call it Grandmother Earth."
    },
    "336": {
        "startTime": 2438.522,
        "endTime": 2449.366,
        "transcript": "It makes us sad many times to see our Grandmother's face all spot up, gouged out, without putting anything good back into it.",
        "translation": "It makes us sad many times to see our Grandmother's face all spot up, gouged out, without putting anything good back into it."
    },
    "337": {
        "startTime": 2449.766,
        "endTime": 2462.121,
        "transcript": "Tua-i-gguq waten man'a-wa tamana Maurluq imutun ilalkumalriacetun [?tugalleqtaarumaluni-llu] ayuqaqami",
        "translation": "He said that when this Grandmother is mistreated and [?gouged]"
    },
    "338": {
        "startTime": 2462.133,
        "endTime": 2464.421,
        "transcript": "Tua-i angniitnarqelartuq.",
        "translation": "It's sad to see."
    },
    "339": {
        "startTime": 2465.533,
        "endTime": 2472.877,
        "transcript": "Every little thing has life. Even a little blade of grass, a little weed has life.",
        "translation": "Every little thing has life. Even a little blade of grass, a little weed has life."
    },
    "340": {
        "startTime": 2472.877,
        "endTime": 2482.866,
        "transcript": "Little tiny bugs, animals, birds, fish, everywhere there's life all around, and we respect them..",
        "translation": "Little tiny bugs, animals, birds, fish, everywhere there's life all around, and we respect them."
    },
    "341": {
        "startTime": 2483.555,
        "endTime": 2489.766,
        "transcript": "Tua-i-gguq ca tamarmi maa-i nunam qaingani uitavimteńi tangllerput",
        "translation": "He said that everything we see on this land where we live"
    },
    "342": {
        "startTime": 2490.066,
        "endTime": 2500.377,
        "transcript": "Naunraunge'rmi wall'u yaquleyagaunge'rmi, caunge'rmi tamarmeng-gguq unguvangqertut.",
        "translation": "He said that everything, even plants or little birds, everything has life."
    },
    "343": {
        "startTime": 2500.388,
        "endTime": 2502.888,
        "transcript": "Anerteqluteng.",
        "translation": "They're alive."
    },
    "344": {
        "startTime": 2502.899,
        "endTime": 2509.144,
        "transcript": "Tua-i-gguq wangkutni nallunritestaitni tamakut qigcignaqluteng.",
        "translation": "He said that we who know about them treat them with respect."
    },
    "345": {
        "startTime": 2510.466,
        "endTime": 2515.888,
        "transcript": "I have learned much from the people from different villages.",
        "translation": "I have learned much from the people from different villages."
    },
    "346": {
        "startTime": 2515.899,
        "endTime": 2524.61,
        "transcript": "They have learned much from this Mother Earth, something they can use in what we call Yup'ik medicine.",
        "translation": "They have learned much from this Mother Earth, something they can use in what we call Yup'ik medicine."
    },
    "347": {
        "startTime": 2524.988,
        "endTime": 2534.899,
        "transcript": "Maa-i-gguq quyungqallemteńi-wa amllermek-wa tua-i elituq yugteggun ayuqenrilngurteggun nallunairumalrianek",
        "translation": "He said that as we've been meeting, he has learned a lot that has been demonstrated through different peoples"
    },
    "348": {
        "startTime": 2534.911,
        "endTime": 2544.733,
        "transcript": "Maaken Aanamteńek Nunamek naumalriamek wangkutnun nunam eyirturtainun atuuyugngalriamek.",
        "translation": "The plants that grow on Mother Earth that are useful for us who populate this earth."
    },
    "349": {
        "startTime": 2547.422,
        "endTime": 2552.433,
        "transcript": "The white man has a word called \"poverty.\"",
        "translation": "The white man has a word called \"poverty.\""
    },
    "350": {
        "startTime": 2553.522,
        "endTime": 2566.9,
        "transcript": "Makut wani qatellriit aipaiput-gguq qaneryarangqertut ava-i qaneryaraitgun apqaqii au͡gna \"poverty.\"",
        "translation": "He said that our white counterparts have a word that he just said in their language, \"poverty.\""
    },
    "351": {
        "startTime": 2566.911,
        "endTime": 2572.833,
        "transcript": "Taringellemtun iqlutun taringumaksailkumku arrsaucimek kangingqertuq.",
        "translation": "In my understanding, if I'm not understanding it wrong, it means to be poor."
    },
    "352": {
        "startTime": 2574.066,
        "endTime": 2579.366,
        "transcript": "Poverty usually means somebody without means, income, money.",
        "translation": "Poverty usually means somebody without means, income, money."
    },
    "353": {
        "startTime": 2579.6,
        "endTime": 2586.233,
        "transcript": "Tamaa-i ava-i nalqigtellemkun poverty, arrsauyaraungan",
        "translation": "Since poverty means to be poor as I just explained"
    },
    "354": {
        "startTime": 2586.233,
        "endTime": 2593.511,
        "transcript": "Kina imna enuqlitellria-wa tua-i canek tamaitnek, enuqitellriim aprutkaa.",
        "translation": "It's a word used for someone who is short on everything, one who lacks."
    },
    "355": {
        "startTime": 2594.6,
        "endTime": 2597.233,
        "transcript": "But there is another poverty:",
        "translation": "But there is another poverty:"
    },
    "356": {
        "startTime": 2597.244,
        "endTime": 2605.233,
        "transcript": "If you have no old people for many knowledge that they have, they don't share and go on and",
        "translation": "If you have no old people for many knowledge that they have, they don't share and go on and"
    },
    "357": {
        "startTime": 2605.233,
        "endTime": 2608.111,
        "transcript": "We are left without nothing, without guidance.",
        "translation": "We are left without nothing, without guidance."
    },
    "358": {
        "startTime": 2608.111,
        "endTime": 2611.577,
        "transcript": "That would be a terrible poverty.",
        "translation": "That would be a terrible poverty."
    },
    "359": {
        "startTime": 2612.11,
        "endTime": 2622.01,
        "transcript": "Cali-gguq nunamiutarteggun-wa tua-i tukuucitgun enuqellratgun yuk arrsauyaaqeciquq.",
        "translation": "He also said that a person may be poor in worldly things, being short on [material] riches."
    },
    "360": {
        "startTime": 2622.366,
        "endTime": 2627.343,
        "transcript": "Tau͡gaa-gguq maa-i cali yuum arrsaucian ilii cali:",
        "translation": "But, he said that this is another part of how a person can be poor:"
    },
    "361": {
        "startTime": 2627.355,
        "endTime": 2637.688,
        "transcript": "Amlleret ciuliat kinguliateng nallunairvikumanritlermegteki camek eliyutkaatnek, nallunritarkaatnek.",
        "translation": "When many elders do not explain to their descendants things that they should learn, that they should know."
    },
    "362": {
        "startTime": 2637.699,
        "endTime": 2642.121,
        "transcript": "Tamaa-i-gguq cali arrsaucim ilakaa.",
        "translation": "He said that's part of being poor."
    },
    "363": {
        "startTime": 2643.111,
        "endTime": 2650.988,
        "transcript": "If you sit in on meetings, you will find that you are very rich.",
        "translation": "If you sit in on meetings, you will find that you are very rich."
    },
    "364": {
        "startTime": 2653.066,
        "endTime": 2659.721,
        "transcript": "If you could sit in on our meetings, hearing these people share their knowledge",
        "translation": "If you could sit in on our meetings, hearing these people share their knowledge"
    },
    "365": {
        "startTime": 2659.732,
        "endTime": 2665.477,
        "transcript": "You will find that you are very rich to have people with this kind of knowledge.",
        "translation": "You will find that you are very rich to have people with this kind of knowledge."
    },
    "366": {
        "startTime": 2665.844,
        "endTime": 2674.711,
        "transcript": "Tua-i-gguq uumirpak quyungqallemteńi qallaquralriatgun niiqurallerput niiqu'rquvciki",
        "translation": "He said that if you listen to the poeple who've been speaking as we've been meeting that we've been listening to"
    },
    "367": {
        "startTime": 2674.721,
        "endTime": 2681.132,
        "transcript": "Tamaaggun-gguq tua-i nallunriryartuci wangkuta imutun tukuulriatun ayuqucimteńek.",
        "translation": "He said that you would find through that it's like we are rich."
    },
    "368": {
        "startTime": 2681.133,
        "endTime": 2689.277,
        "transcript": "Yuut elisngak'ngaarit nallunrilkengait-llu cat nallunairumallruut uumirpak ayagnirraanemteńek.",
        "translation": "People have been explaining things they are knowledgeable about and know since we've started."
    },
    "369": {
        "startTime": 2689.288,
        "endTime": 2696.632,
        "transcript": "Tamaa-i tamaggun cali yuk elisngallermikun tukuulriatun ayuqeciqelliniuq.",
        "translation": "Through a person's knowledge like that, he will be like a rich person."
    },
    "370": {
        "startTime": 2699.077,
        "endTime": 2705.488,
        "transcript": "In sickness, it usually is in the body or in the mind.",
        "translation": "In sickness, it usually is in the body or in the mind."
    },
    "371": {
        "startTime": 2706.01,
        "endTime": 2714.41,
        "transcript": "Naulluunami-gguq yuk naulluulartuq aipaagni tememikun wall'u umyuamikun.",
        "translation": "He said that in sickness, a person is sick either in his body or in his mind."
    },
    "372": {
        "startTime": 2715.555,
        "endTime": 2722.044,
        "transcript": "There is another part of us to make us whole, and that is the soul of man.",
        "translation": "There is another part of us to make us whole, and that is the soul of man."
    },
    "373": {
        "startTime": 2722.655,
        "endTime": 2731.977,
        "transcript": "Cali-gguq tau͡gaam ataucimek pingqertukut wangkuta pimteńek-wa.",
        "translation": "He said that we have one thing of our own."
    },
    "374": {
        "startTime": 2732.099,
        "endTime": 2738.999,
        "transcript": "Tayima nallunrilkuvciu elitaqa'arciiqerci ciuliartaq tarneq.",
        "translation": "If you know the ancestors' concept, you will recognize the soul."
    },
    "375": {
        "startTime": 2739.01,
        "endTime": 2743.221,
        "transcript": "Nalqigtelararput tuquyuilngurput tauna.",
        "translation": "We explain that as the part of us that doesn't die."
    },
    "376": {
        "startTime": 2744.166,
        "endTime": 2752.266,
        "transcript": "We rely great things upon what this soul tells this body and this mind to do.",
        "translation": "We rely great things upon what this soul tells this body and this mind to do."
    },
    "377": {
        "startTime": 2752.411,
        "endTime": 2759.322,
        "transcript": "Tauna-gguq tarnerput wangkuta amllermi cacetuqutek'lararput",
        "translation": "He said that many times, we depend on our soul"
    },
    "378": {
        "startTime": 2759.455,
        "endTime": 2766.977,
        "transcript": "Wangkuta-wa tua-i camek kepqutemteńek-llu umyuarteqaqamta.",
        "translation": "Including when we think about the things we sorely need something."
    },
    "379": {
        "startTime": 2767.91,
        "endTime": 2772.899,
        "transcript": "We feed our bodies, clothe it, wash it.",
        "translation": "We feed our bodies, clothe it, wash it."
    },
    "380": {
        "startTime": 2773.311,
        "endTime": 2779.288,
        "transcript": "We exercise our mind. But what about this soul?",
        "translation": "We exercise our mind. But what about this soul?"
    },
    "381": {
        "startTime": 2779.5,
        "endTime": 2791.9,
        "transcript": "Maa-i-gguq wangkuta temvut una wani caluku cayailkutacetun pilararput, nerevkarluku kenuggluku-llu.",
        "translation": "He said that we do things to our body to protect it, feed and groom it."
    },
    "382": {
        "startTime": 2791.999,
        "endTime": 2797.644,
        "transcript": "Tau͡gaam-gguq tuana imna tuquyuilngurput qaillun piqatarta?",
        "translation": "But, he said, what are we going to do with the part of us that doesn't die?"
    },
    "383": {
        "startTime": 2800.488,
        "endTime": 2806.821,
        "transcript": "This soul, in most every one of us, have experienced poverty",
        "translation": "This soul, in most every one of us, have experienced poverty"
    },
    "384": {
        "startTime": 2806.833,
        "endTime": 2812.788,
        "transcript": "Because we don't nourish it, we don't feed it, we don't exercise it.",
        "translation": "Because we don't nourish it, we don't feed it, we don't exercise it."
    },
    "385": {
        "startTime": 2813.055,
        "endTime": 2822.844,
        "transcript": "Tua-i-gguq maa-i una wani tarnerput amllermi wangkuta imutun arrsauvkalriacetun-wa pilararput",
        "translation": "He said that many times, we cause our soul to be destitute"
    },
    "386": {
        "startTime": 2822.854,
        "endTime": 2827.71,
        "transcript": "Wangkuta tau͡gaam nerevkarinritlemteggun.",
        "translation": "Only because we don't feed it."
    },
    "387": {
        "startTime": 2828.455,
        "endTime": 2838.666,
        "transcript": "As I look around from the very smallest to the very oldest, all of us have souls, and you are beautiful.",
        "translation": "As I look around form the very smallest to the very oldest, all of us have souls, and you are beautiful."
    },
    "388": {
        "startTime": 2839.344,
        "endTime": 2853.244,
        "transcript": "Tua-i-gguq waken tangvaurallermini mikelnguyagarpeceńek ayagluci ciulirneci tekilluki, tua-i-gguq tamarpeci tarnengqertuci.",
        "translation": "He said that as he watches from here, from your very little children to your elders, he said that all of you have souls."
    },
    "389": {
        "startTime": 2853.255,
        "endTime": 2855.421,
        "transcript": "Cali-llu-gguq tangssunaqluci.",
        "translation": "He also said you're beautiful."
    },
    "390": {
        "startTime": 2857.243,
        "endTime": 2863.143,
        "transcript": "All of us have much to contribute, much to give, all of us",
        "translation": "All of us have much to contribute, much to give, all of us"
    },
    "391": {
        "startTime": 2863.977,
        "endTime": 2867.9,
        "transcript": "And be helpful to one another.",
        "translation": "And be helpful to one another."
    },
    "392": {
        "startTime": 2867.921,
        "endTime": 2874.188,
        "transcript": "Tamamta-gguq ilamteńun tamiinun ikayuucugngaukut",
        "translation": "He said that all of us can help those around us"
    },
    "393": {
        "startTime": 2874.188,
        "endTime": 2879.788,
        "transcript": "Cali-llu tamamta cikiutekarluta ikayuutekamteńek ilamteńun.",
        "translation": "And we all have gifts we can use to help those around us."
    },
    "394": {
        "startTime": 2881.844,
        "endTime": 2890.233,
        "transcript": "There was a story of a man who worked on the railroad, come home every other day.",
        "translation": "There was a story of a man who worked on the railroad, come home every other day."
    },
    "395": {
        "startTime": 2890.443,
        "endTime": 2897.866,
        "transcript": "Qanemcitangqertuq-gguq yugmek calilriamek nunakuarcuullugpiit tumyaraitni.",
        "translation": "He said that there's a story of a person who worked on the railroad."
    },
    "396": {
        "startTime": 2897.877,
        "endTime": 2904.077,
        "transcript": "Tauna-gguq yaaliaquaqan tau͡gaam kingunerminun utertetulriamek.",
        "translation": "He said that that person only returned home every other day."
    },
    "397": {
        "startTime": 2906.533,
        "endTime": 2912.888,
        "transcript": "He had three children: one boy, a girl, and another small boy.",
        "translation": "He had three children: one boy, a girl, and another small boy."
    },
    "398": {
        "startTime": 2913.044,
        "endTime": 2921.3,
        "transcript": "Tauna-gguq yungqertuq malrugnek tan'gaurluugnek, nasaurluq-wa-gguq pingayuat.",
        "translation": "He said that that person had two male children, and a girl was the third."
    },
    "399": {
        "startTime": 2922.6,
        "endTime": 2930.033,
        "transcript": "The two older children, the boy and the girl, when they see their dad coming home",
        "translation": "The two older children, the boy and the girl, when they see their dad coming home"
    },
    "400": {
        "startTime": 2930.399,
        "endTime": 2937.111,
        "transcript": "They run out into the field, pick pretty flowers to give to their daddy.",
        "translation": "They run out into the field, pick pretty flowers to give to their daddy."
    },
    "401": {
        "startTime": 2937.377,
        "endTime": 2946.789,
        "transcript": "Tua-llu-gguq taukuk yugkenka ciuqlirraagket malruk tan'gaurluq nasaurlurraq-llu [?].",
        "translation": "Then he said that when the two elders of his children, the boy and the girl, [?]."
    },
    "402": {
        "startTime": 2946.8,
        "endTime": 2952.011,
        "transcript": "Atasek-gguq tauna iluvalliniaqan anqerrlutek paircularaak.",
        "translation": "He said that when their father came into view, they'd go out to meet him."
    },
    "403": {
        "startTime": 2952.021,
        "endTime": 2959.755,
        "transcript": "Tua-i-llu-gguq naunrarnek tangssunarqellrianek qecukaullutek atasek tauna cikiqerluku.",
        "translation": "Then he said that they would pluck out pretty flowers, and give their father [flowers]."
    },
    "404": {
        "startTime": 2959.922,
        "endTime": 2966.744,
        "transcript": "The little boy was paralyzed from waist down. He could not walk or run.",
        "translation": "The little boy was paralyzed from waist down. He could not walk or run."
    },
    "405": {
        "startTime": 2966.788,
        "endTime": 2974.144,
        "transcript": "Tauna-gguq kinguqliq tan'gaurlucuar uatek-gguq nal'aqringauk.",
        "translation": "He said that that youngest boy's waist was paralyzed."
    },
    "406": {
        "startTime": 2975.188,
        "endTime": 2978.199,
        "transcript": "Tarritesciiganani-wa ilagmitun.",
        "translation": "He couldn't walk around like the other two."
    },
    "407": {
        "startTime": 2978.2,
        "endTime": 2980.522,
        "transcript": "Muraggluarnek-llu.",
        "translation": "And little pieces of wood."
    },
    "408": {
        "startTime": 2981.132,
        "endTime": 2987.121,
        "transcript": "When the older boy and girl get the flowers picked",
        "translation": "When the older boy and girl get the flowers picked"
    },
    "409": {
        "startTime": 2987.122,
        "endTime": 2992.811,
        "transcript": "They'd run to meet daddy. \"Here, I picked this for you,\" and give it to him.",
        "translation": "They'd run to meet daddy. \"Here, I picked this for you,\" and give it to him."
    },
    "410": {
        "startTime": 2992.821,
        "endTime": 2997.544,
        "transcript": "He said that because the first two were active and healthy",
        "translation": "He said that because the first two were active and healthy"
    },
    "411": {
        "startTime": 2997.555,
        "endTime": 3003.555,
        "transcript": "Naunrarnek tamaaken teguqauqaarlutek atasek paiqalaraak aqvaqurlutek",
        "translation": "After taking flowers from there, they would run to meet their father"
    },
    "412": {
        "startTime": 3003.555,
        "endTime": 3010.211,
        "transcript": "Qanrulluku waniwa cikirniluku, ellii pitekluku taukunek qecuutellrunilutek.",
        "translation": "Telling him that they're giving him [flowers[, that they had picked them for him."
    },
    "413": {
        "startTime": 3011.099,
        "endTime": 3014.721,
        "transcript": "When dad walked into the yard",
        "translation": "When dad walked into the yard"
    },
    "414": {
        "startTime": 3014.733,
        "endTime": 3024.599,
        "transcript": "This little boy that can't run, can't walk, wanted to give something too, little dirty stick, little dirty rocks.",
        "translation": "This little boy that can't run, can't walk, wanted to give something too, little dirty stick, little dirty rocks."
    },
    "415": {
        "startTime": 3024.61,
        "endTime": 3028.933,
        "transcript": "But in his own way, \"Here, daddy, here.\"",
        "translation": "But in his own way, \"Here, daddy, here.\""
    },
    "416": {
        "startTime": 3029.121,
        "endTime": 3036.266,
        "transcript": "Tua-i-gguq tauna kinguqliak tuaten ilagmitun pisciigalami arenqiallugcami",
        "translation": "He said that because their youngest sibling unfortunately couldn't do as his siblings"
    },
    "417": {
        "startTime": 3036.277,
        "endTime": 3044.599,
        "transcript": "Tua-i atani iluva'rqan paiqerpek'naku tuaten tamakunek teggalquyagarnek tayima muraggluarnek-llu avuqerluni.",
        "translation": "Without meeting his father when he appreaed, he would gather those little rocks and little sticks."
    },
    "418": {
        "startTime": 3044.61,
        "endTime": 3050.388,
        "transcript": "Tekitaqan-gguq tau͡gaam yagutelarai tamakut elliin ataminun cikiutekluki.",
        "translation": "He said that he only extended his hand to give his father those gifts when he arrived."
    },
    "419": {
        "startTime": 3051.166,
        "endTime": 3056.199,
        "transcript": "That's why I say everyone has something to give one another",
        "translation": "That's why I say everyone has something to give one another"
    },
    "420": {
        "startTime": 3056.2,
        "endTime": 3063.055,
        "transcript": "If that one thing that we can give is love from our hearts.",
        "translation": "If that one thing that we can give is love from our hearts."
    },
    "421": {
        "startTime": 3063.421,
        "endTime": 3067.288,
        "transcript": "Taumek-gguq ava-i waten qanlugtellruuq:",
        "translation": "That's why he just said this:"
    },
    "422": {
        "startTime": 3067.299,
        "endTime": 3072.643,
        "transcript": "Tamamta pinrilqurrunata qaqiarrluta cikiutekangqerrniluta ilamteńun.",
        "translation": "All of us, with no exceptions, every one of us has gifts to give those around us."
    },
    "423": {
        "startTime": 3072.655,
        "endTime": 3080.866,
        "transcript": "Tua-i-gguq waniwauguq allamek-wa cikiutekailkumta: kenkaput tau͡gaam ilamteńun atuqumteggu.",
        "translation": "He said that this [is what we can give] if we have no other gifts: only to treat those around us with love."
    },
    "424": {
        "startTime": 3082.111,
        "endTime": 3085.844,
        "transcript": "It is love that unites us together.",
        "translation": "It iis love that unites us together."
    },
    "425": {
        "startTime": 3085.855,
        "endTime": 3089.4,
        "transcript": "Regardless of color, we eat.",
        "translation": "Regardless of color, we eat."
    },
    "426": {
        "startTime": 3089.999,
        "endTime": 3095.377,
        "transcript": "When he pray, he pray to God, \"Thank you for this.\"",
        "translation": "When he pray, he pray to God, \"Thank you for this.\""
    },
    "427": {
        "startTime": 3095.388,
        "endTime": 3101.799,
        "transcript": "When you partake of this food, each one, even a small portion, partake of it",
        "translation": "When you partake of this food, each one, even a small portion, partake of it"
    },
    "428": {
        "startTime": 3101.8,
        "endTime": 3106.866,
        "transcript": "We all became blessed as one people.",
        "translation": "We all became blessed as one people."
    },
    "429": {
        "startTime": 3107.388,
        "endTime": 3116.711,
        "transcript": "Tua-llu taringcetaarutkaa man'a, waten wangkuta ataucimurtelaucirput allakaqtaarluta piurangramta:",
        "translation": "Then he used this as an example of how we are united, though we act as if we are separate:"
    },
    "430": {
        "startTime": 3116.711,
        "endTime": 3122.655,
        "transcript": "Ukut wani neqkaugat amllellrulriit ayuqevkenateng-llu, ayuqenritqapiarluteng",
        "translation": "There were a lot of different foods here, all completely different"
    },
    "431": {
        "startTime": 3122.666,
        "endTime": 3132.322,
        "transcript": "Tau͡gaam piicalqa ava-i qanrutkaa Agayutmun quyatekluki atawaqercetesqumaluki ukut wani akurturpailemteki wangkuta.",
        "translation": "But he spoke of my prayer to God, being thankful for this food and asking for the to be blessed before we received them."
    },
    "432": {
        "startTime": 3132.332,
        "endTime": 3144.266,
        "transcript": "Tua-i-ll' ayuqenritkacagangraata tamamta tua-i uiggalriani tamamta ayuqluta tua-i tamana wangkuta akurturluku atawaqercecimalria wangkutnun.",
        "translation": "Then even though they were completely different, all of us who partook in that received the things that were blessed for us."
    },
    "433": {
        "startTime": 3146.877,
        "endTime": 3155.0,
        "transcript": "Many times, I feel lonely. I'm not alone, but I feel lonely sometimes.",
        "translation": "Many times, I feel lonely. I'm not along, but I feel onely sometimes."
    },
    "434": {
        "startTime": 3156.199,
        "endTime": 3162.666,
        "transcript": "I have a father that died first.",
        "translation": "I have a father that died first."
    },
    "435": {
        "startTime": 3162.677,
        "endTime": 3170.521,
        "transcript": "And then my son was killed when he was 17 years old.",
        "translation": "And then my son was killed when he was 17 years old."
    },
    "436": {
        "startTime": 3171.033,
        "endTime": 3175.544,
        "transcript": "My mother lived to be over 100 years old",
        "translation": "My mother lived to be over 100 years old"
    },
    "437": {
        "startTime": 3175.544,
        "endTime": 3180.522,
        "transcript": "And I buried her not too long ago.",
        "translation": "And I buried her not too long ago."
    },
    "438": {
        "startTime": 3180.811,
        "endTime": 3183.155,
        "transcript": "They're waiting for me.",
        "translation": "They're waiting for me."
    },
    "439": {
        "startTime": 3183.655,
        "endTime": 3188.677,
        "transcript": "But until that day comes when I will go to meet them",
        "translation": "But until that day comes when I will go to meet them"
    },
    "440": {
        "startTime": 3188.799,
        "endTime": 3194.566,
        "transcript": "I want to make the most of this life while I'm still living here today.",
        "translation": "I want to make the most of this life while I'm still living here today."
    },
    "441": {
        "startTime": 3195.166,
        "endTime": 3203.032,
        "transcript": "Maa-i-gguq ellii akuliini aliayularyaaquq angniinani-llu.",
        "translation": "He said that now, he sometimes feels lonely and sad."
    },
    "442": {
        "startTime": 3203.121,
        "endTime": 3210.532,
        "transcript": "Tua-i-gguq-wa ellii atangqellruami, atii-llu yuunrillruluni.",
        "translation": "He said it's because he had a father, and his father passed away."
    },
    "443": {
        "startTime": 3210.533,
        "endTime": 3215.622,
        "transcript": "Nalluvkenaku [?] nani uitanrilucia nallunritaa.",
        "translation": "He knows [?], he knows that they're waiting for him."
    },
    "444": {
        "startTime": 3215.622,
        "endTime": 3226.922,
        "transcript": "Tau͡gaam-gguq cali ilalqerluku qetunrangqellruuq tuqutaullermek ava-i allrakungeqerluni akimiaq malrugnek cipluku.",
        "translation": "But, he said that what exacerbates [his loneliness] is that he had a son who was killed when he was 17 years old."
    },
    "445": {
        "startTime": 3226.932,
        "endTime": 3233.799,
        "transcript": "Tuamta-llu-gguq cali aanangqellruluni, kiituani-llu allrakunguq yuinarnek tallimanek.",
        "translation": "Then, he said that he had a mother who eventually reached 100 years old."
    },
    "446": {
        "startTime": 3233.81,
        "endTime": 3241.099,
        "transcript": "Maa-i-gguq elliin tauna aanani tungmaggnerraraa, nalluvkenaku tau͡gaam nantenrilucia.",
        "translation": "He said that he recently buried his mother, but he knows she's waiting for him."
    },
    "447": {
        "startTime": 3241.1,
        "endTime": 3248.855,
        "transcript": "Taumek-gguq elliin neryuniurutkaa tamana cam iliiniku elliin taukut aliayuutek'lallni tangllerkaatnek.",
        "translation": "That's why he said that he awaits the day when he will see those that he misses so dearly."
    },
    "448": {
        "startTime": 3248.866,
        "endTime": 3258.366,
        "transcript": "Tamana-llu-gguq pitekluku elliin piyuumiutekaa piyunartacirramitun unguvallermini calillerkani nunam qaingani.",
        "translation": "He said that for that reason, he has a desire to work as much as he can on the earth while he's alive."
    },
    "449": {
        "startTime": 3261.01,
        "endTime": 3268.266,
        "transcript": "You have helped to fill the emptiness in my heart",
        "translation": "You have helped to fill the emptiness in my heart"
    },
    "450": {
        "startTime": 3268.277,
        "endTime": 3273.599,
        "transcript": "And I am grateful, and I thank God for all of you.",
        "translation": "And I am grateful, and I thank God for all of you."
    },
    "451": {
        "startTime": 3273.933,
        "endTime": 3277.833,
        "transcript": "Tua-i-gguq waniwa elliin man'a qanrutkaa:",
        "translation": "He said that he speaks of this now:"
    },
    "452": {
        "startTime": 3277.843,
        "endTime": 3285.399,
        "transcript": "Elpeci-gguq waniwa tuarpiaq imaitellranek imilriacetun piarci.",
        "translation": "He said that it truly seems that you have filled what was empty [in his heart]."
    },
    "453": {
        "startTime": 3285.41,
        "endTime": 3291.366,
        "transcript": "Tamana-llu-gguq pitekluku elliin Agayun quyavikaa tamatumek.",
        "translation": "He said that for that reason, he thanks God for that."
    },
    "454": {
        "startTime": 3291.777,
        "endTime": 3294.266,
        "transcript": "God bless you, one and all.",
        "translation": "God bless you, one and all."
    },
    "455": {
        "startTime": 3294.277,
        "endTime": 3298.455,
        "transcript": "Agayutem atawaqertellici tamarpeci.",
        "translation": "May God bless you all."
    },
    "456": {
        "startTime": 3299.622,
        "endTime": 3310.144,
        "transcript": "Yaa, uumek wani quyurvallemteńek wani qaqiutellemteńek wani waniw' piciqua.",
        "translation": "Okay, now I will go over what we established when we held our large gathering."
    },
    "457": {
        "startTime": 3310.155,
        "endTime": 3321.533,
        "transcript": "Makut wani tua-i quyurtesqurluki qaqiutellruukut makut wani yuut tua-i-w' qalarucistait quyurtarkaurrluki.",
        "translation": "We established these meetings where the ones who would speak to people would gather."
    },
    "458": {
        "startTime": 3321.543,
        "endTime": 3329.188,
        "transcript": "Cali makut wani nunat wani makut wani tegganret wani qalarucisteksaurrluki pikumta",
        "translation": "Also, if we in these villages start having these elders become instructors"
    },
    "459": {
        "startTime": 3329.199,
        "endTime": 3337.477,
        "transcript": "Makunun wani ayagyuanun angutnun makut angukarau'urluut piaqluteng",
        "translation": "These old men would speak to these young men"
    },
    "460": {
        "startTime": 3337.488,
        "endTime": 3348.777,
        "transcript": "Makut-llu cali arnassagaat cali makut wani ayagyuat arnat cali qalarutaqluki makunek yuuyaramteńek-wa tua-i qalarulluki.",
        "translation": "And these old women would also instruct these young women about our way of life."
    },
    "461": {
        "startTime": 3348.844,
        "endTime": 3358.066,
        "transcript": "Cali makut wani eitnaurviit wani cali pisqumaluki, man'a pinricetevkarpek'naku:",
        "translation": "We also want these schools to do this, without refraining from doing so:"
    },
    "462": {
        "startTime": 3358.066,
        "endTime": 3364.344,
        "transcript": "Makut wani yumta-wa tua-i yuullratnek tua-i elitnauresqumaluki.",
        "translation": "We want them to teach about our people's lives back then."
    },
    "463": {
        "startTime": 3364.566,
        "endTime": 3377.177,
        "transcript": "Cali makut taangam mat'um wani arenqiallugutii cali ukunun YKHC-nun tua-i umyuaqesqelluku tua-i angluku",
        "translation": "We also want YKHC to greatly consider the negative effects of alcohol"
    },
    "464": {
        "startTime": 3377.188,
        "endTime": 3379.454,
        "transcript": "Tua-i-w' arenqiallugutnguan.",
        "translation": "Because it is a problem."
    },
    "465": {
        "startTime": 3379.488,
        "endTime": 3387.611,
        "transcript": "Cali makut wani tegganret cali maani avatemteńi cali kitugikaaniisqelluki.",
        "translation": "We also want to improve [the care of] the elders here around us."
    },
    "466": {
        "startTime": 3387.621,
        "endTime": 3396.11,
        "transcript": "Makunun wani tegganemteńun aulukellrat-wa tua-i assirikaniisqelluki maani avatemteńi nunani.",
        "translation": "We want the care of our elders here in the villages around us to improve."
    },
    "467": {
        "startTime": 3396.4,
        "endTime": 3406.666,
        "transcript": "Cali makut wani aipanglalriit ilameggnek, cali irniangelalriit pikegtaunrilngurnek.",
        "translation": "Also, these people marry close relatives and have abnormal children."
    },
    "468": {
        "startTime": 3406.666,
        "endTime": 3417.933,
        "transcript": "Cali taman' makunun wani ilakessiyaalrianun wani man'a aipangyaraq pisqumavkenaku qaqiutellruukut.",
        "translation": "We also met about how we don't want these people to marry those to whom they are too closely related."
    },
    "469": {
        "startTime": 3417.988,
        "endTime": 3428.866,
        "transcript": "Cali makut wani tua-i quyurtaaresqurluki makut, mat'umek wani qaqiutellruukut.",
        "translation": "We also met about how we want these people to keep holding meetings."
    },
    "470": {
        "startTime": 3429.444,
        "endTime": 3434.555,
        "transcript": "Tua-i quyurtaararkaurrluta makunek wani Yupiit iinruitnek piluta.",
        "translation": "We will not repeatedly meet about these Yup'ik types of medicine."
    },
    "471": {
        "startTime": 3434.566,
        "endTime": 3445.233,
        "transcript": "Makunek-llu Yupiit tua-i-w' qalaruciyaraat wani yugnek wani caliaqluku cali taman' qaqiutellruukut.",
        "translation": "We also met to work on Yup'ik instruction for people."
    },
    "472": {
        "startTime": 3445.233,
        "endTime": 3448.833,
        "transcript": "Quyaviksuganka ukut wani taillret wani.",
        "translation": "I want to thank these people who came."
    },
    "473": {
        "startTime": 3448.843,
        "endTime": 3455.121,
        "transcript": "Yurartelput Cev'armiut quyaviksugluki cali piukut.",
        "translation": "We also want to thank the people from Chevak who Yup'ik danced for us."
    },
    "474": {
        "startTime": 3455.122,
        "endTime": 3457.244,
        "transcript": "Ukut quyaviksuganka cali:",
        "translation": "I also want to thank these people:"
    },
    "475": {
        "startTime": 3457.254,
        "endTime": 3459.699,
        "transcript": "Kay Nukacuaq Qipnermek taillruuq",
        "translation": "Kay Nukacuaq who came from Kipnuk"
    },
    "476": {
        "startTime": 3459.71,
        "endTime": 3461.988,
        "transcript": "Edith Kawagley Akiarmek",
        "translation": "Edith Kawagley from Akiak"
    },
    "477": {
        "startTime": 3461.999,
        "endTime": 3463.788,
        "transcript": "Wassilie Evan Akiarmek",
        "translation": "Wassilie Evan from Akiak"
    },
    "478": {
        "startTime": 3463.799,
        "endTime": 3466.144,
        "transcript": "Betty Ontom Niugtarmek",
        "translation": "Betty Onton from Newtok"
    },
    "479": {
        "startTime": 3466.154,
        "endTime": 3468.743,
        "transcript": "Lucille Westlock Imangarmek",
        "translation": "Lucille Westlock from Emmonak"
    },
    "480": {
        "startTime": 3468.755,
        "endTime": 3471.666,
        "transcript": "Joseph Qilanaq Cevv'arnermek",
        "translation": "Joseph Qilanaq from Chefornak"
    },
    "481": {
        "startTime": 3471.677,
        "endTime": 3475.388,
        "transcript": "Helen Smith Naparyaarmiunek",
        "translation": "Helen Smith from Hooper Bay"
    },
    "482": {
        "startTime": 3476.143,
        "endTime": 3478.799,
        "transcript": "Joseph Olsen Naparyaarmiu",
        "translation": "Joseph Olsen from Hooper Bay"
    },
    "483": {
        "startTime": 3478.811,
        "endTime": 3481.044,
        "transcript": "Paul Beebe, Kuinerraq",
        "translation": "Paul Beebe, Quinhagak"
    },
    "484": {
        "startTime": 3481.4,
        "endTime": 3484.188,
        "transcript": "Annie Patsy, Mountain Village",
        "translation": "Annie Patsy, Mountain Village"
    },
    "485": {
        "startTime": 3484.199,
        "endTime": 3486.632,
        "transcript": "Mary Andrews, Mountain Village",
        "translation": "Mary Andrews, Mountain Village"
    },
    "486": {
        "startTime": 3486.644,
        "endTime": 3490.166,
        "transcript": "Phillip Foxy, Qerrullik, Kotlik",
        "translation": "Phillip Foxy, Qerrullik, Kotlik"
    },
    "487": {
        "startTime": 3490.177,
        "endTime": 3493.11,
        "transcript": "Jasper Lewis, St. Mary's",
        "translation": "Jasper Lewis, St. Mary's"
    },
    "488": {
        "startTime": 3493.122,
        "endTime": 3496.133,
        "transcript": "Noel Polty, Pilot Station",
        "translation": "Noel Polty, Pilot Station"
    },
    "489": {
        "startTime": 3496.144,
        "endTime": 3499.61,
        "transcript": "And Gusty [?McKell], Stony River-aamek tailleq.",
        "translation": "And Gusty [?McKell] who came from Stony River."
    },
    "490": {
        "startTime": 3499.611,
        "endTime": 3505.777,
        "transcript": "Cali quyaviksugluki makut KYUK-mi calilriit tua-i ikayurpiikut.",
        "translation": "I also want to thank those who work at KYUK because they helped us a lot."
    },
    "491": {
        "startTime": 3505.788,
        "endTime": 3511.144,
        "transcript": "Cali allat wani yuut ikayurillret cali quyaviksugluki.",
        "translation": "I also want to thank other people who've helped."
    },
    "492": {
        "startTime": 3511.154,
        "endTime": 3515.977,
        "transcript": "Quyanaqvaa niicugniluki makut Yuut wani iinrullrit.",
        "translation": "Thank you for listening to these traditional Yup'ik medicine."
    }
};